/** This component is to track the ticket and to view the details of a specific ticket*/

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Send } from "lucide-react";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  getThemeURL,
  grievanceClosed,
  grievanceInprogress,
  grievanceOpen,
  grievanceRejected,
  grievanceResolved,
  getUsersFromAppByRole,
  commentingForAdmins,
  manualEscalateL1,
  manualEscalateL2,
  manualEscalateL3,
  getDepartmentsCurrent,
  getUsersByUserLevelExceptCurrent,
  getAllUserNames,
  getAllPriority,
  createCrossDepartment,
  notificationRead,
  getNotificationsList,
} from "../../../Services/EndPoints";
import { getData } from "../../../Services/ProfileServices";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  postDataWithBody,
  postDataWithFiles,
} from "../../../Services/Services";
import { Modal, Button } from 'react-bootstrap';
import "./RaiseTicket.css";
import { LayoutState } from "../../../Context/LayoutContext/LayoutContext";

const ViewRaisedTicket = () => {
  const location = useLocation();
  const { collapsed } = LayoutState();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [mediaList, setMediaList] = useState([]);
  const [comment, setComment] = useState("");
  const navigate = useNavigate();
  const [comments, setComments] = useState([]);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState(null);
  const [statusError, setStatusError] = useState("");
  const [commentError, setCommentError] = useState("");
  const [UserList, setUserList] = useState([]);
  const [rootCauseError, setRootCauseError] = useState("");
  const [initialStatusOptions, setInitialStatusOptions] = useState([]);
  const ticketData =
    location.state?.data ||
    location.state?.eventData ||
    JSON.parse(sessionStorage.getItem("ticketData"));
  const [currentStatus, setCurrentStatus] = useState(
    ticketData?.status || "Open"
  );
  const isStatusClosedOrRejected =
    ticketData?.status === "Closed" || ticketData?.status === "Rejected";
  const hasActionMessage =
  // eslint-disable-next-line eqeqeq
    ticketData?.originalData?.grievanceTicketMapEntity?.status == 843 ||
    // eslint-disable-next-line eqeqeq
    ticketData?.originalData?.grievanceTicketMapEntity?.status == 844;
  const [fileErrors, setFileErrors] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [isAdmin, setisAdmin] = useState(false);
  const [actionTaken, setActionTaken] = useState("");
  const [rootCause, setRootCause] = useState("");
  const [resolutionSteps, setResolutionSteps] = useState("");
  const [isRootCauseDisabled, setIsRootCauseDisabled] = useState(false);
  const [isActionTakenDisabled, setIsActionTakenDisabled] = useState(false);
  const [isResolutionStepsDisabled, setIsResolutionStepsDisabled] =
    useState(false);
    // eslint-disable-next-line no-unused-vars
  const [isAdminCommenting, setIsAdminCommenting] = useState(false);
  const [userLevel, setUserLevel] = useState(null);
  const [escalationLevel, setEscalationLevel] = useState("");
  const [escalationUserId, setEscalationUserId] = useState(null);

  const [showEscalationModal, setShowEscalationModal] = useState(false);
  const [escalationComment, setEscalationComment] = useState('');
  const [escalationType, setEscalationType] = useState(''); // 'manual' or 'cross'
  const [showCrossDepartmentModal, setShowCrossDepartmentModal] = useState(false);
  const [transferData, setTransferData] = useState({
    targetDepartment: '',
    transferReason: '',
    transferType: '',
    supportingRemarks: ''
  });
  const [crossDepartmentUserId, setCrossDepartmentUserId] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [crossDepartmentLOUsers, setCrossDepartmentLOUsers] = useState([]);
  const [priorityTime, setPriorityTime] = useState(null);
  const [customPriority, setCustomPriority] = useState('');
  const [showTransferReasonModal, setShowTransferReasonModal] = useState(false);
  const [selectedTransferReason, setSelectedTransferReason] = useState("");
  const [isSubmittingCrossDepartment, setIsSubmittingCrossDepartment] = useState(false);
  const [slaDeadlineError, setSlaDeadlineError] = useState("");

  console.log(ticketData?.originalData?.crossDeptDisable, "ticketdata");
  console.log(ticketData, "ticketdata");
  console.log(
    userLevel,
    ticketData.originalData.userLevel,
    "userLeveluserLeveluserLeveluserLevel"
  );
  useEffect(() => {
    fetchUserProfile();
    getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ticketData?.originalData?.grievanceTicketMapEntity) {
      const hasUserLevel =
        "userLevel" in ticketData.originalData.grievanceTicketMapEntity;

      if (!hasUserLevel) {
        setIsAdminCommenting(true);
      }
    }
  }, [ticketData]);
  useEffect(() => {
    if (ticketData?.status) {
      // Create a comprehensive list of all possible statuses that should be available
      const allPossibleStatuses = ["Open", "In Progress", "Resolved", "Closed"];

      // Get the transitions from current status
      const transitions = getStatusTransitions(ticketData.status);

      // Combine current status with its possible transitions, removing duplicates
      const combinedOptions = [ticketData.status, ...transitions];
      const uniqueOptions = [...new Set(combinedOptions)];

      // Ensure we maintain a logical order
      const orderedOptions = allPossibleStatuses.filter((status) =>
        uniqueOptions.includes(status)
      );

      setInitialStatusOptions(orderedOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketData?.status]);

  // Add this useEffect to handle notification matching and marking as read
  useEffect(() => {
    const checkAndMarkNotificationAsRead = async () => {
      if (ticketData?.originalData?.id) {
        try {
          // Get notifications list
          const notificationsResponse = await getData(getNotificationsList);

          if (notificationsResponse?.data?.length > 0) {
            // Find matching notification by reportId
            const matchingNotification = notificationsResponse.data.find(
              (notification) =>
                notification.reportId === ticketData.originalData.id &&
                !notification.isRead
            );

            if (matchingNotification) {
              // Mark notification as read
              const readResponse = await getData(
                notificationRead.replace("ID", matchingNotification.id)
              );

              console.log("Notification marked as read:", readResponse);

              // Optionally refresh notification count in header
              // You can emit a custom event or use a context to refresh the header count
              window.dispatchEvent(new CustomEvent("refreshNotificationCount"));
            }
          }
        } catch (error) {
          console.error("Error checking/marking notification as read:", error);
        }
      }
    };

    // Only run this effect when component mounts and has ticket data
    if (ticketData?.originalData?.id) {
      checkAndMarkNotificationAsRead();
    }
  }, [ticketData?.originalData?.id]); // Dependency on ticket ID

  useEffect(() => {
    if (location.state?.data || location.state?.eventData) {
      sessionStorage.setItem(
        "ticketData",
        JSON.stringify(location.state?.data || location.state?.eventData)
      );
    }
  }, [location.state]);

  //To map existing comments
  useEffect(() => {
    if (
      ticketData?.originalData?.commentsMap &&
      Array.isArray(ticketData.originalData.commentsMap)
    ) {
      const dynamicComments = ticketData.originalData.commentsMap.map(
        (commentData, index) => {
          const formatDate = (dateString) => {
            try {
              const date = new Date(dateString);
              const dd = String(date.getDate()).padStart(2, "0");
              const mm = String(date.getMonth() + 1).padStart(2, "0");
              const yyyy = String(date.getFullYear());

              let hours = date.getHours();
              const minutes = String(date.getMinutes()).padStart(2, "0");
              // const seconds = String(date.getSeconds()).padStart(2, "0");
              const ampm = hours >= 12 ? "PM" : "AM";
              hours = hours % 12 || 12;
              const formattedHours = String(hours).padStart(2, "0");

              return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
            } catch (error) {
              return dateString;
            }
          };

          const generateAvatar = (userName) => {
      if (!userName) return "US";
      
      // Check if userName is an object with label property or a string
      const nameString = userName.label || userName;
      
      if (nameString) {
        const nameParts = nameString.split(" ");
        const firstName = nameParts[0] || "";
        const lastName = nameParts[1] || "";

        const firstChar = firstName.charAt(0).toUpperCase() || "";
        const secondChar = lastName.charAt(0).toUpperCase() || "";

        return `${firstChar}${secondChar}` || "US";
      }
      return "US";
    };

          // const getUserDisplayName = (userId) => {
          //   if (!userId) return "Unknown User";

          //   const user = UserList.find((user) => user.value === userId);
          //   return user ? user.label : `User ${userId}`;
          // };

          const letterCount = commentData.comments
            ? `${commentData.comments.replace(/[^a-zA-Z]/g, "").length}/1000`
            : "0/1000";

          return {
            id: commentData.id || index + 1,
            user: 
              commentData?.userName || commentData?.userName,
            avatar: generateAvatar(
              commentData.userName || commentData.userName
            ),
            date: formatDate(
              commentData.commentsDateAndTime || commentData.createdOn
            ),
            text: commentData.comments || "",
            letterCount: letterCount,
          };
        }
      );

      setComments(dynamicComments);
    } else {
      setComments([]);
    }
  }, [ticketData?.originalData?.commentsMap, UserList]);
  useEffect(() => {
    if (
      ticketData?.originalData?.actionList &&
      ticketData.originalData.actionList.length > 0
    ) {
      const latestAction = ticketData.originalData.actionList[0]; // Get the most recent action
      setActionTaken(latestAction.actionTaken || "");
      setRootCause(latestAction.rootCause || "");
      setResolutionSteps(latestAction.resolutionSteps || "");
    }
  }, [ticketData]);
  // Update the useEffect to handle field states
   useEffect(() => {
      // Reset all fields when status changes to Resolved or Closed from appropriate previous states
      // if (
      //   (currentStatus === "Resolved" && ticketData?.status === "In Progress") ||
      //   (currentStatus === "Closed" && ticketData?.status === "Resolved")
      // ) {
      //   setActionTaken("");
      //   setRootCause("");
      //   setResolutionSteps("");
      // }
  
      console.log(currentStatus,"currentStatuscurrentStatuscurrentStatuscurrentStatus")
  
      // Set field states based on current status
      if (currentStatus === "Open" || currentStatus === "Rejected") {
        // Open, Rejected status - disable all fields
        setIsRootCauseDisabled(true);
        setIsActionTakenDisabled(true);
        setIsResolutionStepsDisabled(true);
      } else if (currentStatus === "In Progress") {
        // In Progress - enable all fields, root cause mandatory
        setIsRootCauseDisabled(false);
        setIsActionTakenDisabled(false);
        setIsResolutionStepsDisabled(false);
      }  else if (currentStatus === "Resolved") {
        // In Progress - enable all fields, root cause mandatory
        setIsRootCauseDisabled(false);
        setIsActionTakenDisabled(false);
        setIsResolutionStepsDisabled(false);
      } else if (currentStatus === "Closed") {
        // Closed - enable all fields for final closure
        setIsRootCauseDisabled(true);
        setIsActionTakenDisabled(true);
        setIsResolutionStepsDisabled(true);
      }
       if (ticketData?.status === "Resolved") {
        // Resolved - disable root cause (show only), enable other fields
        setIsRootCauseDisabled(true); // Disable but show value
        setIsActionTakenDisabled(true);
        setIsResolutionStepsDisabled(true);
      } 
    }, [currentStatus, ticketData?.status]);
// Add this function to reset cross department form data
const resetCrossDepartmentForm = () => {
  setTransferData({
    targetDepartment: '',
    transferReason: '',
    transferType: '',
    supportingRemarks: ''
  });
  setSelectedImages([]);
  setCrossDepartmentUserId(null);
  setCustomPriority(''); // This clears the SLA deadline
  setSlaDeadlineError('');
};
  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUser(response[0].id);
        setUserId(response[0].first_name + (response[0].last_name ? " " + response[0].last_name : ""));
        setUserRole(response[0].role_name);
        setisAdmin(response[0].is_admin);
        setUserLevel(response[0].user_level);
        setEscalationUserId(response[0].id);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

const openTransferReasonModal = (reason) => {
  setSelectedTransferReason(reason);
  setShowTransferReasonModal(true);
};

const closeTransferReasonModal = () => {
  setShowTransferReasonModal(false);
  setSelectedTransferReason("");
};

const onEscalationLevelChange = (e) => {
  const level = e.target.value;
  setEscalationLevel(level);
  if (level) {
    setEscalationComment(''); // Reset comment when level changes
    setShowEscalationModal(true);
  }
};
const handleEscalationModalClose = () => {
  setShowEscalationModal(false);
  if (escalationType === 'manual') {
    setEscalationLevel(''); // Reset the escalation level when modal is closed
  }
  setEscalationComment(''); // Also reset the comment
};

const submitEscalation = async () => {
  if (escalationComment.trim() === '') {
    toast.error('Comment is required');
    return;
  }

  try {
    const formDataToSend = new FormData();

    // Determine the correct remark field based on escalation level
    let remarkField;
    if (escalationLevel === 'L1') {
      remarkField = 'escalateRemarks1';
    } else if (escalationLevel === 'L2') {
      remarkField = 'escalateRemarks2';
    } else if (escalationLevel === 'L3') {
      remarkField = 'escalateRemarks3';
    }

    const payload = {
      id: ticketData?.originalData?.id,
      updatedby: escalationUserId,
      [remarkField]: escalationComment,  // Dynamic property name
    };
    
    formDataToSend.append('grievance', JSON.stringify(payload));
    const emptyBlob = new Blob([], { type: "application/octet-stream" });
    formDataToSend.append("files", emptyBlob, "empty.bin");

    let response;
    if (escalationLevel === 'L1') {
      response = await postDataWithBody(manualEscalateL1, formDataToSend, {});
    } else if (escalationLevel === 'L2') {
      response = await postDataWithBody(manualEscalateL2, formDataToSend, {});
    } else if (escalationLevel === 'L3') {
      response = await postDataWithBody(manualEscalateL3, formDataToSend, {});
    }

    if (response && response.status === "success") {
      toast.success(response.msg || `Ticket escalated to ${escalationLevel} successfully!`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      
      const updatedTicketData = {
        ...ticketData,
        originalData: {
          ...ticketData.originalData,
          userLevel: escalationLevel // Update the userLevel in the ticket data
        }
      };

      sessionStorage.setItem("ticketData", JSON.stringify(updatedTicketData));
      // Don't reset escalationLevel here - let it remain so the dropdown shows the selected value
      
      navigate("../grievance");
    } else {
      throw new Error(response?.msg || "Failed to escalate ticket");
    }
  } catch (error) {
    console.error("Escalation error:", error);
    toast.error(error.message || "Failed to escalate ticket", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
    // On error, also reset the escalation level
    setEscalationLevel('');
  } finally {
    setShowEscalationModal(false);
    setEscalationComment('');
  }
};

// Add this helper function before handleCrossDepartmentTransfer
const formatDateTimeForAPI = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  const date = new Date(dateTimeString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const formattedHours = String(hours).padStart(2, '0');
  
  return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
};

const handleCrossDepartmentTransfer = async () => {
  // Validate required fields
  // if (!transferData.targetDepartment || !transferData.transferReason || !transferData.transferType || !crossDepartmentUserId) {
  if (!transferData.targetDepartment || !transferData.transferReason) {
    toast.error('Please fill all required fields');
    return;
  }

  if (customPriority) {
    const selectedDateTime = new Date(customPriority);
    const currentDateTime = new Date();
    
    // Set seconds and milliseconds to 0 for fair comparison
    selectedDateTime.setSeconds(0, 0);
    currentDateTime.setSeconds(0, 0);
    
    if (selectedDateTime < currentDateTime) {
      setSlaDeadlineError("SLA deadline cannot be in the past. Please choose a valid future date and time.");
      // toast.error("SLA deadline validation failed. Please update the deadline.");
      return;
    }
  }

  // Set loading state
  setIsSubmittingCrossDepartment(true);

  try {
    const formDataToSend = new FormData();
    
    // Calculate priority date time
    const priorityDateTime = customPriority || calculatePriorityDateTime();
    
    const payload = {
      grievanceSeqIdString: ticketData?.id,
      targetDepartmentId: parseInt(transferData.targetDepartment),
      transferReason: transferData.transferReason,
      transferType: transferData.transferType,
      initiatedBy: parseInt(ticketData?.originalData?.createdBy),
      createdBy: crossDepartmentUserId ? parseInt(crossDepartmentUserId) : parseInt(ticketData?.originalData?.createdBy),
      userLevel: ticketData?.userLevels,
      currentStatus: parseInt(ticketData?.originalData?.status),
      resSLADateAndTimeString: priorityDateTime ? formatDateTimeForAPI(priorityDateTime) : "",
      is_deleted:false,      
    };
    
    formDataToSend.append('transfer', JSON.stringify(payload));
    
    // Append files if any are selected
    if (selectedImages && selectedImages.length > 0) {
      selectedImages.forEach((imgObj) => {
        if (imgObj.file instanceof File) {
          formDataToSend.append("files", imgObj.file);
        }
      });
    } else {
      const emptyBlob = new Blob([], { type: "application/octet-stream" });
      formDataToSend.append("files", emptyBlob, "empty.bin");
    }

    // Call the API endpoint
    const response = await postDataWithFiles(createCrossDepartment, formDataToSend);

    if (response && response.status === "success") {
      toast.success(response.msg || "Ticket transferred to cross department successfully!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      
      // Reset form and close modal
      setTransferData({
        targetDepartment: '',
        transferReason: '',
        transferType: '',
        supportingRemarks: ''
      });
      setSelectedImages([]);
      setCrossDepartmentUserId(null);
      setCustomPriority('');
      setSlaDeadlineError('');
      setShowCrossDepartmentModal(false);
      
      // Navigate back
      navigate("../grievance");
    } else {
      throw new Error(response?.msg || "Failed to transfer ticket to cross department");
    }
  } catch (error) {
    console.error("Cross department transfer error:", error);
    toast.error(error.message || "Failed to transfer ticket to cross department", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  }
  finally {
    // Reset loading state whether success or error
    setIsSubmittingCrossDepartment(false);
  }
};

const getDepartments = async (assignedTeamId) => {
  try {
    const response = await getData(getDepartmentsCurrent.replace("DEPTID", assignedTeamId));
    if (Array.isArray(response)) {
      setDepartments(response);
    } else {
      setDepartments([]);
    }
  } catch (error) {
    console.error("Error fetching departments:", error);
    setDepartments([]);
    toast.error("Failed to load departments", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  }
};
useEffect(() => {
  if (ticketData?.originalData?.assignedTeam) {
    getDepartments(ticketData.originalData.assignedTeam);
  }
}, [ticketData?.originalData?.assignedTeam]);

const getCrossDepartmentLOUsers = async (userId, userLevelFromTheme) => {
  try {
    let response;
    
    // If user is L2 or L3, use getAllUserNames
    if (userLevelFromTheme === "L1") {
      response = await getData(getUsersByUserLevelExceptCurrent.replace("USERID", userId));
    } else if (userLevelFromTheme === "L2" || userLevelFromTheme === "L3") {
      response = await getData(getAllUserNames.replace("USERLEVEL", "L1"));
    }
    
    if (Array.isArray(response)) {
      setCrossDepartmentLOUsers(response);
    } else {
      setCrossDepartmentLOUsers([]);
    }
  } catch (error) {
    console.error("Error fetching cross department users:", error);
    setCrossDepartmentLOUsers([]);
    toast.error("Failed to load users", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  }
};

useEffect(() => {
  if (user && userLevel) {
    getCrossDepartmentLOUsers(user, userLevel);
  }
}, [user, userLevel]);

const fetchPriorityData = async (selectedPriority) => {
  try {
    const response = await getData(getAllPriority.replace("PRIORITY", selectedPriority));
    console.log("Priority response:", response);
    setPriorityTime(response);
  } catch (error) {
    console.error("Error fetching priority data", error);
  }
};
useEffect(() => {
  if (showCrossDepartmentModal && ticketData?.criticality) {
    fetchPriorityData(ticketData.criticality);
  }
}, [showCrossDepartmentModal, ticketData?.criticality]);

const calculatePriorityDateTime = () => {
  if (!priorityTime) return '';
  
  const currentDate = new Date();
  let targetDate = new Date(currentDate);
  
  const { maxResTimeValue, maxResTimeType } = priorityTime;
  
  if (maxResTimeType === 'Minutes') {
    targetDate.setMinutes(targetDate.getMinutes() + maxResTimeValue);
  } else if (maxResTimeType === 'Hours') {
    targetDate.setHours(targetDate.getHours() + maxResTimeValue);
  } else if (maxResTimeType === 'Days') {
    let daysToAdd = maxResTimeValue;
    let daysAdded = 0;
    
    while (daysAdded < daysToAdd) {
      targetDate.setDate(targetDate.getDate() + 1);
      // Skip Sundays (0 = Sunday)
      if (targetDate.getDay() !== 0) {
        daysAdded++;
      }
    }
  }
  
  // Format to datetime-local input format (YYYY-MM-DDTHH:mm)
  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');
  const hours = String(targetDate.getHours()).padStart(2, '0');
  const minutes = String(targetDate.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        getUserList(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.is_admin === true) {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  const getUserList = async (profile) => {
    // setLoader(true);
    try {
      const payload = createPayload(profile);
      const fetchedUsers = await postDataWithBody(
        getUsersFromAppByRole,
        payload,
        {}
      );
      const sortedUsers = fetchedUsers.sort((a, b) =>
        a.first_name > b.first_name ? 1 : -1
      );
      const userList = sortedUsers.map((user) => ({
        label: `${user.first_name} ${user.last_name}`,
        value: user.id,
        created_by: user.created_by,
      }));
      setUserList(userList);
    } catch (error) {
      console.error("Error fetching user list:", error);
      toast.error("Failed to load user list");
    } finally {
    }
  };

  useEffect(() => {
    if (ticketData?.mediaList && ticketData.mediaList.length > 0) {
      setMediaList(ticketData.mediaList);
    }
  }, [ticketData]);

  const displayData = (data) => data || "N/A";

  // Add this function with your other helper functions
const formatReopenedDateTime = (dateString) => {
  if (!dateString) return "N/A";
  
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original if invalid date
    }
    
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear());

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
  } catch (error) {
    console.error("Error formatting reopened date:", error);
    return dateString || "N/A";
  }
};

  //styling for status
  const getStatusStyling = (status) => {
    if (!status)
      return {
        dotColor: "#808080",
        textColor: "#6b7280",
      };

    let dotColor, textColor;
    switch (status) {
      case "Open":
        dotColor = "rgba(233, 80, 96, 0.5)";
        textColor = "#E95060";
        break;
      case "Closed":
        dotColor = "#22c55e";
        textColor = "#166534";
        break;
      case "In Progress":
        dotColor = "#f59e0b";
        textColor = "#92400e";
        break;
      case "Rejected":
        dotColor = "#dc3545";
        textColor = "#dc3545";
        break;
      default:
        dotColor = "#6b7280";
        textColor = "#6b7280";
    }
    return { dotColor, textColor };
  };

  //styling for criticality
  const getPriorityStyling = (priority) => {
    if (!priority)
      return {
        dotColor: "#808080",
        textColor: "#6b7280",
      };

    let dotColor, textColor;
    switch (priority.toUpperCase()) {
      case "CRITICAL":
      case "HIGH":
        dotColor = "#ef4444";
        textColor = "#db0404";
        break;
      case "MEDIUM":
        dotColor = "#f59e0b";
        textColor = "#FFA100";
        break;
      case "LOW":
        dotColor = "#1a7a73";
        textColor = "#40BAC2";
        break;
      default:
        dotColor = "#6b7280";
        textColor = "#808080";
    }
    return { dotColor, textColor };
  };
// eslint-disable-next-line no-unused-vars
  const statusStyling = getStatusStyling(ticketData?.status);
  // eslint-disable-next-line no-unused-vars
  const priorityStyling = getPriorityStyling(ticketData?.criticality);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isTextFieldDisable } = location.state || {};
  // const ticketSteps = ["Open", "In Progress", "Resolved", "Closed"];
  // const rejectedSteps = ["Open", "Rejected"];
  const [showModal, setShowModal] = useState(false);
  // const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const getFileNameWithoutExtension = (fileName) => {
    if (!fileName) return "Untitled";
    return fileName.replace(/\.[^/.]+$/, "");
  };
  const isPdfFile = (filePath) => {
    return filePath?.toLowerCase().endsWith(".pdf");
  };

const getDynamicSteps = (currentStatus, ticketData) => {
  console.log(currentStatus, "Current Status");
  const allSteps = ["Open", "In Progress", "Resolved", "Closed"];
  const rejectedSteps = ["Open", "Rejected"];
  
  // If current status is Rejected, show rejected flow
  if (currentStatus === "Rejected") {
    return rejectedSteps;
  }
  
  // Show all remaining steps when ticket is in Open or In Progress (UNCHANGED)
  if (currentStatus === "Open" || currentStatus === "In Progress") {
    return allSteps;
  }
  
  // Get status history from submitted records
  const statusHistory = ticketData?.originalData?.grievanceStatusMapEntities || [];
  
  // Check if current status exists in history (means it's been submitted)
  const hasCurrentStatusInHistory = statusHistory.some(item => 
    item?.statusText?.toLowerCase() === currentStatus?.toLowerCase()
  );
  
  // ONLY FIX: Handle specific cases when changing status before submission
  // after "In Progress" or "Resolved" has been submitted
  if (!hasCurrentStatusInHistory && statusHistory.length > 0) {
    // Handle "Closed" case
    if (currentStatus === "Closed") {
      // Sort by createdOn to get chronological order
      const sortedHistory = [...statusHistory].sort((a, b) => 
        new Date(a.createdOn) - new Date(b.createdOn)
      );
      
      // Extract unique status names from history and build the correct path
      const statusesFromHistory = [...new Set(sortedHistory.map(item => item.statusText))];
      const orderedPath = [];
      
      // Always start with Open
      orderedPath.push("Open");
      
      // Add In Progress if it exists in history
      if (statusesFromHistory.includes("In Progress")) {
        orderedPath.push("In Progress");
      }
      
      // Add Resolved if it exists in history
      if (statusesFromHistory.includes("Resolved")) {
        orderedPath.push("Resolved");
      }
      
      // Add Closed (current selection)
      orderedPath.push("Closed");
      
      return orderedPath;
    }
    
    // NEW FIX: Handle "Resolved" case
    if (currentStatus === "Resolved") {
      // Sort by createdOn to get chronological order
      const sortedHistory = [...statusHistory].sort((a, b) => 
        new Date(a.createdOn) - new Date(b.createdOn)
      );
      
      // Extract unique status names from history and build the correct path
      const statusesFromHistory = [...new Set(sortedHistory.map(item => item.statusText))];
      const orderedPath = [];
      
      // Always start with Open
      orderedPath.push("Open");
      
      // Add In Progress if it exists in history
      if (statusesFromHistory.includes("In Progress")) {
        orderedPath.push("In Progress");
      }
      
      // Add Resolved (current selection)
      orderedPath.push("Resolved");
      
      // Add Closed to complete the flow
      orderedPath.push("Closed");
      
      return orderedPath;
    }
  }
  
  // If current status is NOT in history yet (before submission) - UNCHANGED BEHAVIOR
  if (!hasCurrentStatusInHistory) {
    const originalStatus = statusHistory.length > 0 ? 
      statusHistory.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn))[0].statusText : 
      "Open";
    
    // Before submission: show intended path (UNCHANGED)
    if (originalStatus === "Open" && currentStatus === "Resolved") {
      return ["Open", "Resolved", "Closed"];
    }
    if (originalStatus === "Open" && currentStatus === "Closed") {
      return ["Open", "Closed"];
    }
    if (originalStatus === "In Progress" && currentStatus === "Closed") {
      return ["Open", "In Progress", "Closed"];
    }
    
    // Default: show all steps for other cases (UNCHANGED)
    return allSteps;
  }
  
  // If current status IS in history (after submission), build ORDERED path from history (UNCHANGED)
  if (statusHistory.length > 0) {
    const sortedHistory = [...statusHistory].sort((a, b) => 
      new Date(a.createdOn) - new Date(b.createdOn)
    );
    
    const statusesFromHistory = [...new Set(sortedHistory.map(item => item.statusText))];
    const orderedPath = [];
    
    if (statusesFromHistory.includes("Open")) {
      orderedPath.push("Open");
    }
    
    if (statusesFromHistory.includes("In Progress")) {
      orderedPath.push("In Progress");
    }
    
    if (statusesFromHistory.includes("Resolved")) {
      orderedPath.push("Resolved");
    }
    
    if (statusesFromHistory.includes("Closed") || currentStatus === "Resolved" || currentStatus === "Closed") {
      if (!orderedPath.includes("Closed")) {
        orderedPath.push("Closed");
      }
    }
    
    console.log("Ordered Path from History:", orderedPath);
    return orderedPath;
  }
  
  // Default fallback (UNCHANGED)
  return allSteps;
};

  const getCurrentStepIndex = () => {
    const steps = getDynamicSteps(currentStatus, ticketData);
    const stepIndex = steps.findIndex(
      (step) => step.toLowerCase() === (currentStatus || "").toLowerCase()
    );
    return stepIndex === -1 ? 0 : stepIndex;
  };

  const handleCommentChange = (e) => {
    const inputText = e.target.value;
    if (inputText.replace(/[^a-zA-Z]/g, "").length <= 1000) {
      setComment(inputText);
    }
  };

  const handleStatusChange = (e) => {
  const newStatus = e.target.value;
  setCurrentStatus(newStatus);
  setStatusError("");
};
  //uplaod comments
  const handleCommentSubmit = () => {
  if (comment.trim()) {
    // Check character count again before submitting
    if (comment.replace(/[^a-zA-Z]/g, "").length > 1000) {
      setCommentError("Comment exceeds 1000 character limit");
      return;
    }
 
    let avatar = "";
    const words = userId.split(/\s+/);
   
    // Updated avatar generation logic
    if (words.length >= 2) {
      // For 2 or more words: first letter of first word + first letter of second word
      avatar = (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    } else if (words.length === 1 && words[0].length >= 2) {
      // For single word with 2+ characters: first letter only
      avatar = words[0].charAt(0).toUpperCase();
    } else if (words.length === 1 && words[0].length === 1) {
      // For single character word: use that character only
      avatar = words[0].toUpperCase();
    } else {
      // Fallback
      avatar = "US";
    }
 
    const date = new Date();
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear()).toString();
 
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    // const seconds = String(date.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;
    const formattedDateTime = `${dd}-${mm}-${yyyy} ${formattedTime}`;
 
    const newComment = {
      id: comments.length + 1,
      user: userId,
      avatar: avatar,
      date: formattedDateTime,
      text: comment,
      letterCount: comment.replace(/[^a-zA-Z]/g, "").length,
    };
 
    setComments([...comments, newComment]);
    setComment("");
    setStatusError("");
    setCommentError("");
  }
};

  //upload media
  const handleMediaClick = (media, index) => {
    setCurrentImageIndex(index);
    setModalContent({
      ...media,
      isPdf: isPdfFile(media.mediaPath),
    });
    setShowModal(true);
  };

  const MediaModal = () => {
    const [imageZoom, setImageZoom] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    if (!showModal || !modalContent) return null;

    const handleZoomIn = () => {
      setImageZoom((prev) => Math.min(prev + 0.25, 3));
    };

    const handleZoomOut = () => {
      setImageZoom((prev) => Math.max(prev - 0.25, 0.25));
    };

    const handleResetZoom = () => {
      setImageZoom(1);
      setImagePosition({ x: 0, y: 0 });
    };

    const handleMouseDown = (e) => {
      if (imageZoom > 1) {
        setIsDragging(true);
        setDragStart({
          x: e.clientX - imagePosition.x,
          y: e.clientY - imagePosition.y,
        });
      }
    };

    const handleMouseMove = (e) => {
      if (isDragging && imageZoom > 1) {
        setImagePosition({
          x: e.clientX - dragStart.x,
          y: e.clientY - dragStart.y,
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleWheel = (e) => {
      e.preventDefault();
      if (e.deltaY < 0) {
        handleZoomIn();
      } else {
        handleZoomOut();
      }
    };

    const isImage =
      modalContent.type === "image" ||
      modalContent.mediaPath
        ?.toLowerCase()
        .match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);
    const isPdf =
      modalContent.type === "pdf" ||
      modalContent.isPdf ||
      modalContent.mediaPath?.toLowerCase().includes(".pdf");

    return (
      <div
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) setShowModal(false);
        }}
      >
        <div
          className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
          style={{
            backgroundColor: "white",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
            animation: "fadeIn 0.3s ease-out",
            border: "1px solid #e0e0e0",
            display: "flex",
            marginLeft: "60px",
            flexDirection: "column",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 20px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <h2
                  style={{
                    fontWeight: "600",
                    fontSize: "18px",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  {getFileNameWithoutExtension(modalContent.fileName)}
                </h2>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {/* Zoom Controls for Images */}
              {isImage && (
                <>
                  <button
                    onClick={handleZoomOut}
                    style={{
                      background: "#f5f5f5",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      width: "32px",
                      height: "32px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "16px",
                      color: "#666",
                    }}
                    title="Zoom Out"
                  >
                    −
                  </button>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      minWidth: "40px",
                      textAlign: "center",
                    }}
                  >
                    {Math.round(imageZoom * 100)}%
                  </span>
                  <button
                    onClick={handleZoomIn}
                    style={{
                      background: "#f5f5f5",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      width: "32px",
                      height: "32px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "16px",
                      color: "#666",
                    }}
                    title="Zoom In"
                  >
                    +
                  </button>
                  <button
                    onClick={handleResetZoom}
                    style={{
                      background: "#f5f5f5",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "6px 10px",
                      cursor: "pointer",
                      fontSize: "12px",
                      color: "#666",
                    }}
                    title="Reset Zoom"
                  >
                    Reset
                  </button>
                </>
              )}

              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#888",
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                &times;
              </button>
            </div>
          </div>

          {/* Document Preview Area */}
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              padding: "0",
              minHeight: 0, // This ensures proper flex behavior
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: isImage ? "center" : "stretch",
                padding: isImage ? "20px" : "0",
                backgroundColor: isImage ? "#f9f9f9" : "#fff",
                overflow: isImage && imageZoom > 1 ? "hidden" : "auto",
                minHeight: 0, // Prevents overflow issues
              }}
            >
              {/* PDF Preview */}
              {isPdf ? (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <iframe
                    src={modalContent.url || modalContent.mediaPath}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      borderRadius: "4px",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      minHeight: "500px",
                    }}
                    title={modalContent.name || modalContent.fileName}
                  />
                </div>
              ) : /* Image Preview with Zoom */
              isImage ? (
                <div
                  style={{
                    width: "100%",
                    height: "70vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    cursor:
                      imageZoom > 1
                        ? isDragging
                          ? "grabbing"
                          : "grab"
                        : "default",
                    position: "relative",
                  }}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                  onWheel={handleWheel}
                >
                  <img
                    src={modalContent.url || modalContent.mediaPath}
                    alt={modalContent.name || modalContent.fileName}
                    style={{
                      maxWidth: imageZoom === 1 ? "100%" : "none",
                      maxHeight: imageZoom === 1 ? "100%" : "none",
                      transform: `scale(${imageZoom}) translate(${imagePosition.x / imageZoom}px, ${imagePosition.y / imageZoom}px)`,
                      transition: isDragging ? "none" : "transform 0.2s ease",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      objectFit: "contain",
                      userSelect: "none",
                      pointerEvents: "none",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    draggable={false}
                  />
                </div>
              ) : (
                /* Unsupported Format */
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "30px",
                    borderRadius: "8px",
                    textAlign: "center",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      backgroundColor: "#f0f0f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 15px",
                      fontSize: "24px",
                      color: "#888",
                    }}
                  >
                    📄
                  </div>
                  <h3 style={{ marginBottom: "10px", color: "#333" }}>
                    Preview not available
                  </h3>
                  <p style={{ color: "#666", marginBottom: "20px" }}>
                    Only images and PDF files can be previewed.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Document Information Footer */}
          <div
            style={{
              borderTop: "1px solid #f0f0f0",
              padding: "16px 20px",
              backgroundColor: "#FAFAFA",
            }}
          ></div>
        </div>
      </div>
    );
  };

  // Update your handleSubmit function to use the state values instead of querying DOM
  const handleSubmit = async () => {
    // Clear previous errors
    setRootCauseError("");
    setStatusError("");
    setCommentError("");
    if (
      (currentStatus === "In Progress" || currentStatus === "Resolved") &&
      !rootCause.trim()
    ) {
      const statusMessage =
        currentStatus === "In Progress"
          ? "Root cause is mandatory for In Progress status"
          : "Root cause is required before resolving the ticket";
      setRootCauseError(statusMessage);
      return;
    }

    const originalCommentsCount =
      ticketData?.originalData?.commentsMap?.length || 0;
    const newComments = comments.slice(originalCommentsCount);
    if (newComments.length === 0) {
      setCommentError("Please add a comment before submitting");
      return;
    }

    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();

      const newCommentsForSubmission = newComments.map((comment) => ({
        grievanceId: ticketData.originalData.id,
        commentsUpdatedBy: user,
        createdBy: user,
        comments: comment.text,
        commentsDateAndTimeString: comment.date,
      }));

      const grievanceData = {
        id: ticketData.originalData.id,
        updated_by: user,
        currentAction: {
          assignedTo: user,
          actionTaken: actionTaken,
          rootCause: rootCause,
          resolutionSteps: resolutionSteps,
        },
        commentsMap: newCommentsForSubmission,
      };

      formDataToSend.append("grievance", JSON.stringify(grievanceData));

      if (selectedImages && selectedImages.length > 0) {
        selectedImages.forEach((imgObj) => {
          if (imgObj.file instanceof File) {
            formDataToSend.append("files", imgObj.file);
          }
        });
      } else {
        const emptyBlob = new Blob([], { type: "application/octet-stream" });
        formDataToSend.append("files", emptyBlob, "empty.bin");
      }

      let response;
      console.log("currentStatus", currentStatus);

      // Determine if userLevel is present
      const hasUserLevel = userLevel !== null && userLevel !== undefined;

      // Determine if status dropdown should be disabled (same conditions as UI)
      const shouldDisableStatusDropdown = hasUserLevel
        ? isStatusClosedOrRejected ||
          hasActionMessage ||
          userRole === "SUPER ADMIN" ||
          isAdmin === true ||
          ticketData.status === "Escalated to L2" ||
          ticketData.originalData.grievanceTicketMapEntity?.disable === true ||
          ticketData.originalData.accept === false
        : isAdmin === true ||
          ticketData.originalData.grievanceTicketMapEntity.disable === true ||
          ticketData.status === "Resolved" ||
          ticketData.originalData.grievanceTicketMapEntity?.disable !== false;

      // API call logic
      const isStatusChanging = currentStatus !== ticketData?.status;
      const isCommentOnlyUpdate =
        !isStatusChanging &&
        comments.length > (ticketData?.originalData?.commentsMap?.length || 0);

      if (hasUserLevel && shouldDisableStatusDropdown && isCommentOnlyUpdate) {
        // Use admin commenting API only for comment-only updates when status dropdown is disabled
        console.log(
          "Using admin commenting API - comment-only update with disabled status"
        );
        response = await postDataWithFiles(commentingForAdmins, formDataToSend);
      } else {
        // Use status-based API for all status changes and when status dropdown is enabled
        console.log("Using status-based API");
        if (currentStatus === "Open") {
          response = await postDataWithFiles(grievanceOpen, formDataToSend);
        } else if (currentStatus === "In Progress") {
          response = await postDataWithFiles(
            grievanceInprogress,
            formDataToSend
          );
        } else if (currentStatus === "Resolved") {
          response = await postDataWithFiles(grievanceResolved, formDataToSend);
        } else if (currentStatus === "Closed") {
          response = await postDataWithFiles(grievanceClosed, formDataToSend);
        } else if (currentStatus === "Rejected") {
          response = await postDataWithFiles(grievanceRejected, formDataToSend);
        }
      }

      if (response.status === "success") {
        toast.success(response.msg || "Grievance updated successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate(-1);
      } else {
        throw new Error(response.msg || "Failed to update grievance");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to update grievance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
    ];
    const maxSize = 1 * 1024 * 1024; // 1MB
    const maxFiles = 5;

    const newErrors = [];

    if (selectedImages.length + files.length > maxFiles) {
      newErrors.push(`You can only upload a maximum of ${maxFiles} files.`);
      e.target.value = "";
      setFileErrors(newErrors);
      return;
    }

    const validFiles = [];

    files.forEach((file) => {
      if (!allowedTypes.includes(file.type)) {
        newErrors.push(
          `File "${file.name}" has an invalid type. Only JPG, PNG, GIF, and PDF are allowed.`
        );
        return;
      }

      if (file.size > maxSize) {
        newErrors.push(`File "${file.name}" exceeds the 1MB limit.`);
        return;
      }

      validFiles.push(file);
    });

    setFileErrors(newErrors);

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages((prevImages) => [
          ...prevImages,
          { file, preview: reader.result },
        ]);
      };
      reader.readAsDataURL(file);
    });

    e.target.value = "";
  };

  const isPdf = (file) => {
    return file.type === "application/pdf";
  };

  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  const getStatusTransitions = (currentStatus) => {
    const status = currentStatus || ticketData?.status;

    switch (status) {
      case "Open":
        return ["In Progress", "Resolved", "Closed"];
      case "In Progress":
        return ["Resolved", "Closed"];
      case "Resolved":
        return ["Closed"];
      case "Closed":
        return []; // No transitions from Closed
      case "Rejected":
        return []; // No transitions from Rejected
      default:
        return [];
    }
  };

  useEffect(() => {
    setCurrentStatus(ticketData?.status || "Open");
  }, [ticketData?.status]);

  const currentStep = getCurrentStepIndex();

  //Progress bar section UI
  const renderProgressTracker = () => {
const steps = getDynamicSteps(currentStatus, ticketData);
    const getStatusColor = (status) => {
      const statusColors = {
        open: "#D90429",
        "in progress": "#f97316",
        resolved: "#10b981",
        closed: "#304FFE",
        reject: "#ef4444",
        rejected: "#B00020",
      };
      return statusColors[status.toLowerCase()] || "#6b7280"; // default to grey
    };

    const getSegmentColor = (fromStatus, toStatus) => {
      const from = fromStatus.toLowerCase();
      const to = toStatus.toLowerCase();

      if (from === "open" && to === "in progress") {
        return "#D90429"; // blue (open to in progress)
      } else if (from === "in progress" && to === "resolved") {
        return "#f97316"; // orange (in progress to resolved)
      } else if (from === "resolved" && to === "closed") {
        return "#10b981"; // green (resolved to closed)
      } else if (to === "reject" || to === "rejected") {
        return "#B00020"; // red (reject)
      } else {
        return getStatusColor(fromStatus);
      }
    };

    return (
      <div
        className="mb-4"
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px 24px",
            color: "#1a7a73",
          }}
        >
          <h6
            style={{
              fontSize: "15px",
              fontWeight: "600",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <i
              className="bi bi-graph-up-arrow"
              style={{ fontSize: "15px" }}
            ></i>
            Track your Ticket
          </h6>
        </div>

        {/* Content */}
        <div style={{ padding: "24px", marginTop: "-15px" }}>
          <div
            className="d-flex justify-content-between align-items-center position-relative"
            style={{ marginBottom: "25px" }}
          >
            {/* Background line */}
            <div
              style={{
                position: "absolute",
                height: "4px",
                backgroundColor: "#f1f5f9",
                width: "calc(100% - 29px)",
                left: "9px",
                top: "9px",
                zIndex: 1,
                borderRadius: "2px",
              }}
            ></div>

            {/* Progressive colored segments */}
            {steps.map((step, segmentIndex) => {
              if (segmentIndex >= steps.length - 1) return null;

              const segmentWidth = `calc(${100 / (steps.length - 1)}% - ${80 / (steps.length - 0.3)}px)`;
              const segmentLeft = `calc(${(segmentIndex * 100) / (steps.length - 1)}% + 9px)`;
              const isActive = segmentIndex < currentStep;

              const fromStatus = steps[segmentIndex];
              const toStatus = steps[segmentIndex + 1];
              const segmentColor = getSegmentColor(fromStatus, toStatus);

              return (
                <div
                  key={`segment-${segmentIndex}`}
                  style={{
                    position: "absolute",
                    height: "4px",
                    backgroundColor: isActive ? segmentColor : "#f1f5f9",
                    width: segmentWidth,
                    left: segmentLeft,
                    top: "9px",
                    zIndex: 2,
                    borderRadius: "2px",
                    transition: "all 0.5s ease-in-out",
                  }}
                ></div>
              );
            })}

            {steps.map((step, index) => {
              const statusColor = getStatusColor(step);
              const isActive = index <= currentStep;
              const isCurrent = index === currentStep;

              return (
                <div
                  key={index}
                  className="d-flex flex-column align-items-center position-relative"
                  style={{ zIndex: 3 }}
                >
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: isActive ? statusColor : "#e2e8f0",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "12px",
                      transition: "all 0.3s ease",
                      border: isCurrent
                        ? "3px solid #ffffff"
                        : "2px solid #ffffff",
                      boxShadow: isActive
                        ? `0 2px 8px ${statusColor}40`
                        : "0 1px 3px rgba(0, 0, 0, 0.1)",
                      boxSizing: "border-box",
                    }}
                  >
                    {index < currentStep && (
                      <i
                        className="bi bi-check text-white"
                        style={{ fontSize: "12px", fontWeight: "bold" }}
                      ></i>
                    )}
                    {isCurrent && currentStep !== 0 && (
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: "#ffffff",
                          animation: "pulse 2s infinite",
                        }}
                      ></div>
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: "13px",
                      color: isActive ? "#374151" : "#9ca3af",
                      fontWeight: isCurrent ? 600 : 500,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      transition: "color 0.3s ease",
                    }}
                  >
                    {step}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Progress info */}
          {/* <div className="mt-3 d-flex align-items-center justify-content-center">
          <small style={{ 
            color: "#64748b", 
            fontSize: "13px",
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}>
            <i className="bi bi-info-circle"></i>
            Step {currentStep + 1} of {steps.length}: {steps[currentStep]}
          </small>
        </div> */}
        </div>

        <style jsx>{`
          @keyframes pulse {
            0%,
            100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}</style>
      </div>
    );
  };

  //attachement section UI
  const renderAttachmentsSection = () => {
    if (
      isStatusClosedOrRejected ||
      hasActionMessage ||
      userRole === "SUPER ADMIN" ||
      isAdmin === true
    )
      return null;

    return (
      <div
        className="mb-4"
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            // background: "linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)",
            padding: "20px 24px",
            color: "#1a7a73",
          }}
        >
          <h6
            style={{
              fontSize: "15px",
              fontWeight: "600",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <i className="bi bi-paperclip" style={{ fontSize: "15px" }}></i>
            Attachments
          </h6>
        </div>

        {/* Content */}
        <div style={{ padding: "15px", marginTop: "-15px" }}>
          <div
            className="border rounded-3 p-4 text-center position-relative"
            style={{
              minHeight: "120px",
              background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
              border: "2px dashed #a78bfa !important",
              transition: "all 0.3s ease",
            }}
          >
            <input
              type="file"
              className="d-none"
              id="attachments"
              onChange={handleImageChange}
              multiple
              accept=".jpg,.jpeg,.png,.gif,.pdf"
            />
            <label
              htmlFor="attachments"
              className="mb-0 w-100 h-100"
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-column align-items-center justify-content-center h-100">
                <i
                  className="bi bi-cloud-upload"
                  style={{
                    fontSize: "30px",
                    color: "#8b5cf6",
                    marginBottom: "10px",
                  }}
                ></i>
                <div style={{ color: "#FFA100", fontSize: "14px" }}>
                  Click here to browse
                </div>
              </div>
            </label>

            {selectedImages.length > 0 && (
              <div className="mt-4 d-flex flex-wrap justify-content-center gap-3">
                {selectedImages.map((imgObj, index) => (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      borderRadius: "10px",
                      overflow: "visible",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    {isPdf(imgObj.file) ? (
                      <div
                        style={{
                          width: "100px",
                          height: "100px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          background:
                            "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
                          borderRadius: "10px",
                          border: "2px solid #f87171",
                          padding: "8px",
                        }}
                      >
                        <i
                          className="bi bi-file-earmark-pdf"
                          style={{
                            fontSize: "28px",
                            color: "#dc2626",
                            marginBottom: "4px",
                          }}
                        ></i>
                        <div
                          style={{
                            fontSize: "10px",
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%",
                            color: "#dc2626",
                            fontWeight: "600",
                          }}
                        >
                          {imgObj.file.name}
                        </div>
                      </div>
                    ) : (
                      <img
                        src={imgObj.preview}
                        alt={`preview-${index}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                    )}
                    <button
                      onClick={() => removeImage(index)}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        color: "#374151",
                        border: "2px solid #e5e7eb",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f9fafb",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                        transition: "all 0.2s ease",
                        fontWeight: "bold",
                        zIndex: 10,
                      }}
                      title="Remove attachment"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.1)";
                        e.currentTarget.style.background = "#ef4444";
                        e.currentTarget.style.color = "white";
                        e.currentTarget.style.borderColor = "#dc2626";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.background = "#f9fafb";
                        e.currentTarget.style.color = "#374151";
                        e.currentTarget.style.borderColor = "#e5e7eb";
                      }}
                    >
                      <i
                        className="bi bi-x"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1",
                          marginLeft: "-22px",
                        }}
                      ></i>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-3 d-flex align-items-center justify-content-between">
            <small style={{ color: "#64748b", fontSize: "13px" }}>
              <i className="bi bi-info-circle me-1"></i>
              Allowed formats: JPG, PNG, GIF, PDF (max 1MB each, 5 files
              maximum)
            </small>
          </div>

          {fileErrors.length > 0 && (
            <div className="mt-3">
              {fileErrors.map((error, index) => (
                <div
                  key={index}
                  className="alert alert-danger py-2 px-3 mb-2"
                  style={{
                    fontSize: "13px",
                    borderRadius: "8px",
                    border: "1px solid #fecaca",
                    backgroundColor: "#fef2f2",
                  }}
                >
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {error}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  //submit buttons UI
  const renderSubmitButtons = () => {
    if (
      isStatusClosedOrRejected ||
      hasActionMessage ||
      userRole === "SUPER ADMIN" ||
      isAdmin === true
    ) {
      return (
        <div className="d-flex justify-content-center gap-2 mt-2">
          <div style={{ width: "90%", maxWidth: "600px" }}>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="branch-save-submit-btn btn btn-success"
                onClick={handleCancel}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center gap-2 mt-2">
        <div style={{ width: "90%", maxWidth: "600px" }}>
          {(rootCauseError || commentError) && (
            <div
              className="alert alert-danger mb-2"
              style={{ height: "auto", width: "100%", padding: "0.5rem" }}
              role="alert"
            >
              {rootCauseError || commentError}
            </div>
          )}
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "0rem" }}
          >
            <button
              type="button"
              className="branch-save-submit-btn btn btn-success"
              onClick={handleSubmit}
              disabled={isSubmitting || isTextFieldDisable}
            >
              {isSubmitting ? "Submitting..." : "Save & Submit"}
            </button>
            <button
              type="button"
              className="branch-save-submit-btn btn btn-success"
              style={{ marginLeft: "15px" }}
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  //comment section UI
  const renderCommentsSection = () => {
    if (hasActionMessage || isAdmin === true) return null;

    return (
      <div
        className="mb-4"
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            //background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
            padding: "20px 24px",
            color: "#1a7a73",
          }}
        >
          <h6
            style={{
              fontSize: "15px",
              fontWeight: "600",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <i className="bi bi-chat-dots" style={{ fontSize: "15px" }}></i>
            Comments
          </h6>
        </div>

        {/* Content */}
        <div style={{ padding: "15px", marginTop: "-15px" }}>
          <div className="comments-list mb-4">
            {comments.length > 0 ? (
              comments.map((comment) => (
                <div
                  key={comment.id}
                  className="d-flex mb-4 p-3"
                  style={{
                    backgroundColor: "#f8fafc",
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "#1a7a73",
                      color: "white",
                      marginRight: "16px",
                      flexShrink: 0,
                      fontSize: "12px",
                      fontWeight: "600",
                      //boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)"
                    }}
                  >
                    {comment.avatar}
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "12px",
                          color: "#1e293b",
                        }}
                      >
                        {comment.user}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#64748b",
                          backgroundColor: "#f1f5f9",

                          borderRadius: "6px",
                        }}
                      >
                        {comment.date}
                      </div>
                    </div>
                    <div
                      style={{
                        color: "#475569",
                        marginTop: "-8px",
                        // lineHeight: "1.5",
                        fontSize: "14px",
                      }}
                    >
                      {comment.text}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                className="text-center py-2"
                style={{
                  background:
                    "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                  borderRadius: "12px",
                  border: "2px dashed #cbd5e1",
                }}
              >
                <p
                  className="text-muted mt-3 mb-2"
                  style={{ fontSize: "14px", fontWeight: "500" }}
                >
                  No comments available
                </p>
              </div>
            )}
          </div>

          {!isStatusClosedOrRejected &&
            !hasActionMessage &&
            userRole !== "SUPER ADMIN" && (
              <div className="d-flex">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "#1a7a73",
                    color: "white",
                    marginRight: "14px",
                    flexShrink: 0,
                    //boxShadow: "0 4px 12px rgba(245, 158, 11, 0.3)"
                  }}
                >
                  <FaUser size={18} />
                </div>
                <div
                  className="position-relative flex-grow-1"
                  style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <textarea
                    placeholder="Write your comment here..."
                    value={comment}
                    onChange={handleCommentChange}
                    className="form-control"
                    style={{
                      border:
                        comment.replace(/[^a-zA-Z]/g, "").length >= 1000
                          ? "1px solid #ef4444"
                          : "1px solid #d1d5db",
                      backgroundColor: "#ffffff",
                      minHeight: "80px",
                      borderRadius: "12px 12px 0 0",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      padding: "16px",
                    }}
                  />
                  <div
                    className="d-flex justify-content-between align-items-center px-4 py-3"
                    style={{
                      backgroundColor: "#f8fafc",
                      borderTop: "1px solid #e5e7eb",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        color:
                          comment.replace(/[^a-zA-Z]/g, "").length >= 1000
                            ? "#ef4444"
                            : "#64748b",
                        fontWeight: "500",
                        marginLeft: "-30px",
                      }}
                    >
                      <i className="bi"></i>
                      {comment.replace(/[^a-zA-Z]/g, "").length}/1000 characters
                      {comment.replace(/[^a-zA-Z]/g, "").length >= 1000 && (
                        <span className="ms-2 text-danger">
                          <i className="bi bi-exclamation-triangle me-1"></i>
                          Character limit reached
                        </span>
                      )}
                    </div>
                    <button
                      onClick={handleCommentSubmit}
                      style={{
                        background: "#1a7a73",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        padding: "8px 16px",
                        color: "white",
                        fontSize: "10px",
                        fontWeight: "500",
                        boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(16, 185, 129, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 8px rgba(16, 185, 129, 0.3)";
                      }}
                    >
                      <Send size={16} className="me-1" />
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  };

  //total page UI
  const renderTicketView = () => {
    // eslint-disable-next-line no-unused-vars
    const transitions = getStatusTransitions(currentStatus);

    return (
      <div
        className="container-fluid p-0"
        style={{ backgroundColor: "#f8fafc" }}
      >
        <div className="row g-0">
          <div className="col-md-12 p-4">
            <div key={currentStatus}>
  {renderProgressTracker()}
</div>

            {/* Grievance Information Card */}
            <div
              className="mb-4"
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e2e8f0",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                style={{
                  //background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  padding: "20px 24px",
                  //  marginLeft:'-10px',
                  color: "#1a7a73",
                }}
              >
                <h6
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i
                    className="bi bi-ticket-detailed"
                    style={{ fontSize: "15px" }}
                  ></i>
                  Grievance Information
                </h6>
              </div>

              {/* Content */}
              <div style={{ padding: "15px", marginTop: "-15px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: "14px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Grievance ID
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.id)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Subject
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.subject)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Issue Reported Date & Time
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.date)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Priority
                    </p>
                    <div className="mb-0">
                      <span
                        style={{
                          color: "#1e293b",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                      >
                        {ticketData?.criticality || "N/A"}
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Bank Name
                    </p>
                    <div
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.bank)}
                    </div>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Branch Name
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.branch)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Assigned Department
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.originalData.assignedTeamName)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Category
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.type)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Subcategory
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.issueTypeSubCatName)}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div
                      style={{
                        // gridColumn: "1 / -1",
                        padding: "20px",
                        // marginTop: "-10px",
                        // backgroundColor: "#f1f5f9",
                        // borderRadius: "12px",
                        // border: "1px solid #cbd5e1"
                      }}
                    >
                      <p
                        className="mb-3"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Description
                      </p>
                      <div
                        className="mb-0"
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.6",
                          color: "#334155",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            ticketData?.originalData.description ||
                            ticketData?.details ||
                            "N/A",
                        }}
                      />
                    </div>
                  </div>
                  
                </div>
{/* Status & Actions Information Card */}
<div className="mb-4" style={{
  backgroundColor: 'white', 
  borderRadius: '10px', 
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', 
  border: '1px solid #e2e8f0', 
  overflow: 'hidden'
}}>
  {/* Header */}
  <div style={{
    background: 'white', 
    padding: '20px 24px', 
    color: '#1a7a73'
  }}>
    <h6 style={{
      fontSize: '15px', 
      fontWeight: '600', 
      margin: '0', 
      display: 'flex', 
      alignItems: 'center', 
      gap: '8px'
    }}>
      <i className="bi bi-gear" style={{fontSize: '15px'}}></i>
      Action Desk
    </h6>
  </div>
                <div class="row">
                  <div className={userLevel !== "L1" && userLevel !== "L2" && userLevel !== "L3" ? "col-2" : "col-6"}>
                    <div
                      style={{
                        padding: "16px",
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Status
                      </p>
                      <div className="mb-0">
                        {(() => {
                          // Check if user_level exists in the themeURL response
                          const hasUserLevel =
                            userLevel !== null && userLevel !== undefined;

                          // Get the current user ID from your user profile
                          const currentUserId = user; // This should be the logged-in user's ID

                          // Determine if dropdown should be disabled with user-specific acceptance checks
                          const shouldDisableDropdown = hasUserLevel
                            ? isStatusClosedOrRejected ||
                              hasActionMessage ||
                              userRole === "SUPER ADMIN" ||
                              isAdmin === true ||
                              ticketData.status === "Escalated to L2" ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable === true ||
                              // Level-specific acceptance checks - only enable for the user who accepted
                              (userLevel === "L1" &&
                                (ticketData.originalData.accept === false ||
                                  (ticketData.originalData.accept === true &&
                                    ticketData.originalData.acceptedBy !==
                                      currentUserId))) ||
                              (userLevel === "L2" &&
                                (ticketData.originalData.acceptToL2 === false ||
                                  (ticketData.originalData.acceptToL2 ===
                                    true &&
                                    ticketData.originalData.acceptedByL2 !==
                                      currentUserId))) ||
                              (userLevel === "L3" &&
                                (ticketData.originalData.acceptToL3 === false ||
                                  (ticketData.originalData.acceptToL3 ===
                                    true &&
                                    ticketData.originalData.acceptedByL3 !==
                                      currentUserId)))
                            : isAdmin === true || isStatusClosedOrRejected || userRole === "SUPER ADMIN" ||
                              ticketData.status === "Resolved" ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable !== false;
                          return shouldDisableDropdown ? (
                            // Display static status (read-only)
                            <div
                              style={{
                                fontWeight: "600",
                                color:
                                  currentStatus === "Open"
                                    ? "#D90429"
                                    : currentStatus === "Closed"
                                      ? "#304FFE"
                                      : currentStatus === "In Progress"
                                        ? "#FF7F11"
                                        : currentStatus === "Resolved"
                                          ? "#228B22"
                                          : currentStatus === "Rejected"
                                            ? "#B00020"
                                            : "#6b7280",
                                fontSize: "14px",
                                padding: "6px 12px",
                                backgroundColor:
                                  currentStatus === "Open"
                                    ? "#FDE2E4"
                                    : currentStatus === "Closed"
                                      ? "#E0E8F9"
                                      : currentStatus === "In Progress"
                                        ? "#FFF1E6"
                                        : currentStatus === "Resolved"
                                          ? "#E2F0CB"
                                          : currentStatus === "Rejected"
                                            ? "#FBE3E8"
                                            : "#f9fafb",
                                borderRadius: "8px",
                                display: "inline-block",
                              }}
                            >
                              {currentStatus}
                            </div>
                          ) : (
                            // Display editable dropdown
                            <select
                              className="form-select"
                              style={{
                                display: "inline-block",
                                width: "auto",
                                minWidth: "150px",
                                maxWidth: "100%",
                                borderColor: "black",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                fontSize: "14px",
                                backgroundColor: "white",
                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                fontWeight: "500",
                              }}
                              value={currentStatus}
                              onChange={handleStatusChange}
                            >
                              {/* Current status as first option */}
                              {/* <option value={currentStatus}>
                                {currentStatus}
                              </option> */}

                              {/* Available transitions - exclude Closed when userLevel is absent */}
                              {initialStatusOptions
                                .filter((option) => {
                                  // When userLevel is absent, exclude "Closed" from available options
                                  if (!hasUserLevel) {
                                    return option !== "Closed";
                                  }
                                  // When userLevel is present, show all available transitions
                                  return true;
                                })
                                .map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                            </select>
                          );
                        })()}
                        {statusError && (
                          <div
                            className="text-danger small mt-2"
                            style={{ fontSize: "12px" }}
                          >
                            {statusError}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {userLevel !== "L1" && userLevel !== "L2" && userLevel !== "L3" && (
                  <div class="col-4">
                    <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Currently Handled By Department
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.originalData.handledBy)}
                    </p>
                  </div>
                  </div>
                  )}
                  <div class="col-6">
                    <div style={{ padding: "16px" }}>
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Action Taken
                        {currentStatus !== "Open" &&
                          currentStatus !== "Resolved" && (
                            <span
                              style={{
                                color: "#6b7280",
                                fontSize: "11px",
                                fontWeight: "normal",
                              }}
                            >
                              {" "}
                              {/* (Optional) */}
                            </span>
                          )}
                      </p>
                      <div className="mb-0">
                        {(() => {
                          // Check if user_level exists in the themeURL response
                          const hasUserLevel =
                            userLevel !== null && userLevel !== undefined;

                          // Get the current user ID from your user profile
                          const currentUserId = user; // This should be the logged-in user's ID

                          // Determine if dropdown should be disabled with user-specific acceptance checks
                          const shouldDisableDropdown = hasUserLevel
                            ? isStatusClosedOrRejected ||
                              hasActionMessage ||
                              userRole === "SUPER ADMIN" ||
                              isAdmin === true ||
                              ticketData.status === "Escalated to L2" ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable === true ||
                              // Level-specific acceptance checks - only enable for the user who accepted
                              (userLevel === "L1" &&
                                (ticketData.originalData.accept === false ||
                                  (ticketData.originalData.accept === true &&
                                    ticketData.originalData.acceptedBy !==
                                      currentUserId))) ||
                              (userLevel === "L2" &&
                                (ticketData.originalData.acceptToL2 === false ||
                                  (ticketData.originalData.acceptToL2 ===
                                    true &&
                                    ticketData.originalData.acceptedByL2 !==
                                      currentUserId))) ||
                              (userLevel === "L3" &&
                                (ticketData.originalData.acceptToL3 === false ||
                                  (ticketData.originalData.acceptToL3 ===
                                    true &&
                                    ticketData.originalData.acceptedByL3 !==
                                      currentUserId)))
                            : isAdmin === true || isStatusClosedOrRejected ||
                              ticketData.status === "Resolved" ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable !== false;

                          return shouldDisableDropdown ? (
                            // Display static text (read-only)
                            <p
                              className="mb-0"
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#1e293b",
                                padding: "8px 12px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                minHeight: "47px",
                              }}
                            >
                              {actionTaken || "N/A"}
                            </p>
                          ) : (
                            // Display editable textarea
                            <textarea
                              className="form-control"
                              style={{
                                width: "100%",
                                height: "47px",
                                borderColor: "black",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                fontSize: "14px",
                                backgroundColor: "white",
                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                fontWeight: "500",
                              }}
                              placeholder="action taken..."
                              value={actionTaken}
                              onChange={(e) => setActionTaken(e.target.value)}
                              disabled={isActionTakenDisabled}
                            />
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div style={{ padding: "16px" }}>
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Root Cause
                        {(currentStatus === "In Progress" ||
                            currentStatus === "Resolved") && (
                            <span
                              style={{
                                color: "#dc2626",
                                fontSize: "11px",
                                fontWeight: "normal",
                              }}
                            >
                              {" "}
                              *
                            </span>
                          )}
                      </p>
                      <div className="mb-0">
                        {(() => {
                          // Check if user_level exists in the themeURL response
                          const hasUserLevel =
                            userLevel !== null && userLevel !== undefined;

                          // Get the current user ID from your user profile
                          const currentUserId = user; // This should be the logged-in user's ID

                          // Determine if dropdown should be disabled with user-specific acceptance checks
                          const shouldDisableDropdown = hasUserLevel
                            ? isStatusClosedOrRejected ||
                              hasActionMessage ||
                              userRole === "SUPER ADMIN" ||
                              isAdmin === true ||
                              ticketData.status === "Escalated to L2" ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable === true ||
                              // Level-specific acceptance checks - only enable for the user who accepted
                              (userLevel === "L1" &&
                                (ticketData.originalData.accept === false ||
                                  (ticketData.originalData.accept === true &&
                                    ticketData.originalData.acceptedBy !==
                                      currentUserId))) ||
                              (userLevel === "L2" &&
                                (ticketData.originalData.acceptToL2 === false ||
                                  (ticketData.originalData.acceptToL2 ===
                                    true &&
                                    ticketData.originalData.acceptedByL2 !==
                                      currentUserId))) ||
                              (userLevel === "L3" &&
                                (ticketData.originalData.acceptToL3 === false ||
                                  (ticketData.originalData.acceptToL3 ===
                                    true &&
                                    ticketData.originalData.acceptedByL3 !==
                                      currentUserId)))
                            : isAdmin === true || 
                              ticketData.status === "Resolved" || isStatusClosedOrRejected ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable !== false;
                          return shouldDisableDropdown ? (
                            // Display static text (read-only)
                            <p
                              className="mb-0"
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#1e293b",
                                padding: "8px 12px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                minHeight: "47px",
                              }}
                            >
                              {rootCause || "N/A"}
                            </p>
                          ) : (
                            <>
                              <textarea
                                className="form-control"
                                style={{
                                  width: "100%",
                                  height: "47px",
                                  borderColor:
                                    !rootCause.trim() &&
                                      (currentStatus === "In Progress" ||
                                        currentStatus === "Resolved")
                                        ? "#dc2626"
                                        : "black",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  fontSize: "14px",
                                  backgroundColor: "white",
                                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                  fontWeight: "500",
                                }}
                                placeholder="root cause..."
                                value={rootCause}
                                onChange={(e) => {
                                  setRootCause(e.target.value);
                                  if (rootCauseError) setRootCauseError(""); // Clear error when user starts typing
                                }}
                                disabled={isRootCauseDisabled}
                                required={
                                  currentStatus !== "Open" &&
                                  currentStatus !== "Resolved"
                                }
                              />
                              {rootCauseError && (
                                <div
                                  className="text-danger small mt-2"
                                  style={{
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <i className="bi bi-exclamation-triangle"></i>
                                  {rootCauseError}
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div style={{ padding: "16px" }}>
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Workaround/Resolution Steps
                        {currentStatus !== "Open" && (
                          <span
                            style={{
                              color: "#6b7280",
                              fontSize: "11px",
                              fontWeight: "normal",
                            }}
                          >
                            {" "}
                            {/* (Optional) */}
                          </span>
                        )}
                      </p>
                      <div className="mb-0">
                        {(() => {
                          // Check if user_level exists in the themeURL response
                          const hasUserLevel =
                            userLevel !== null && userLevel !== undefined;

                          // Get the current user ID from your user profile
                          const currentUserId = user; // This should be the logged-in user's ID

                          // Determine if dropdown should be disabled with user-specific acceptance checks
                          const shouldDisableDropdown = hasUserLevel
                            ? isStatusClosedOrRejected ||
                              hasActionMessage ||
                              userRole === "SUPER ADMIN" ||
                              isAdmin === true ||
                              ticketData.status === "Escalated to L2" ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable === true ||
                              // Level-specific acceptance checks - only enable for the user who accepted
                              (userLevel === "L1" &&
                                (ticketData.originalData.accept === false ||
                                  (ticketData.originalData.accept === true &&
                                    ticketData.originalData.acceptedBy !==
                                      currentUserId))) ||
                              (userLevel === "L2" &&
                                (ticketData.originalData.acceptToL2 === false ||
                                  (ticketData.originalData.acceptToL2 ===
                                    true &&
                                    ticketData.originalData.acceptedByL2 !==
                                      currentUserId))) ||
                              (userLevel === "L3" &&
                                (ticketData.originalData.acceptToL3 === false ||
                                  (ticketData.originalData.acceptToL3 ===
                                    true &&
                                    ticketData.originalData.acceptedByL3 !==
                                      currentUserId)))
                            : isAdmin === true ||
                              ticketData.status === "Resolved" || isStatusClosedOrRejected ||
                              ticketData.originalData.grievanceTicketMapEntity
                                ?.disable !== false;

                          return shouldDisableDropdown ? (
                            // Display static text (read-only)
                            <p
                              className="mb-0"
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#1e293b",
                                padding: "8px 12px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                minHeight: "47px",
                              }}
                            >
                              {resolutionSteps || "N/A"}
                            </p>
                          ) : (
                            // Display editable textarea
                            <textarea
                              className="form-control"
                              style={{
                                width: "100%",
                                height: "47px",
                                borderColor: "black",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                fontSize: "14px",
                                backgroundColor: "white",
                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                fontWeight: "500",
                              }}
                              placeholder="workaround/resolution steps..."
                              value={resolutionSteps}
                              onChange={(e) =>
                                setResolutionSteps(e.target.value)
                              }
                              disabled={isResolutionStepsDisabled}
                            />
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Action Message Field - Only show if actionMessage exists in grievanceEntityMap */}

{ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage && (
  <div className="row">
    <div className="col-12">
      <div style={{ padding: "16px" }}>
    <p className="mb-2" style={{
      color: '#FFA100',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '0.5px',
    }}>
      Action Message
    </p>
    <div className="mb-0">
      <p className="mb-0" style={{
        fontWeight: 500,
        fontSize: '14px',
        color: '#1e293b',
        padding: '8px 0px',
        backgroundColor: 'transparent',
        borderRadius: '8px',
        minHeight: 'auto',
      }}>
        {ticketData.originalData.grievanceTicketMapEntity.actionMessage}
      </p>
    </div>
  </div>
  </div>
  </div>
)}

                {hasActionMessage && (
                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#fffbeb",
                      // borderRadius: "12px",
                      // border: "1px solid #fbbf24"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#92400e",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Action Message
                    </p>
                    <div
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#92400e",
                      }}
                    >
                      {
                        ticketData?.originalData?.grievanceTicketMapEntity
                          ?.actionMessage
                      }
                    </div>
                  </div>
                )}
              {userLevel && (
                <div class="row">
                  <div class="col-7">
    {/* Escalation Type Selection */}
    <div style={{ padding: "16px"}}>
      <p
        className="mb-2"
        style={{
          color: "#FFA100",
          fontSize: "12px",
          fontWeight: "600",
          letterSpacing: "0.5px",
        }}
      >
        Action Type
      </p>
      <div style={{display:"flex"}}>
                      <div className="mb-0" style={{
                          width:
                            isStatusClosedOrRejected ||
                            hasActionMessage ||
                            userRole === "SUPER ADMIN" ||
                            isAdmin === true ||
                            ticketData.originalData.grievanceTicketMapEntity.disable === true ||
                            userLevel !== ticketData.originalData.userLevel
                              ? "60%"
                              : "46%",
                        }}>
                        {isStatusClosedOrRejected ||
                          hasActionMessage ||
                          userRole === "SUPER ADMIN" ||
                          isAdmin === true ||
                          ticketData.originalData.grievanceTicketMapEntity.disable === true ||
                          userLevel !== ticketData.originalData.userLevel ? (
                          <>
                          <div style={{display:"flex"}}>
                          <select
                            className="form-select"
                            style={{
                              borderColor: "black",
                              borderRadius: "8px",
                              fontSize: "14px",
                              backgroundColor: "#f8f9fa",
                              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                              fontWeight: "500",
                              opacity: 0.4, // Slightly reduce opacity instead of heavy graying
                              color: "#666"
                            }}
                            disabled={true}
                            value=""
                          >
                            <option value="">Select Type</option>
                            <option value="manual">Manual Escalation</option>
                            <option value="cross">Cross Department Transfer</option>
                          </select>
                          <div style={{width:"150%"}}>
                          <p className="mb-2" style={{ color: "#FFA100", fontSize: "12px", fontWeight: "600", letterSpacing: "0.5px",marginTop:"-24px",marginLeft:"67px" }}>
                            Escalation Level
                          </p>
                          <div className="mb-0">
                      <p className="mb-0" style={{
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#1e293b',
                        padding: '8px 0px',  // Removed horizontal padding for plain text look
                        backgroundColor: 'transparent',  // Removed background color
                        borderRadius: '8px',
                        minHeight: 'auto',  // Removed fixed height
                        marginLeft: "110px"
                      }}>
                        {ticketData.originalData.userLevel ?
                          `${ticketData.originalData.userLevel}` :
                          'NA'
                        }
                      </p>
                    </div>
                          </div>
                          </div>
                          </>
                        ) : (
                          <select
                            className="form-select"
                            style={{
                              borderColor: "black",
                              borderRadius: "8px",
                              fontSize: "14px",
                              backgroundColor: "white",
                              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                              fontWeight: "500",
                              opacity: (() => {
                                const hasUserLevel = userLevel !== null && userLevel !== undefined;
                                const currentUserId = user;
                                const shouldDisableDropdown = hasUserLevel
                                  ? isStatusClosedOrRejected ||
                                  hasActionMessage ||
                                  userRole === "SUPER ADMIN" ||
                                  isAdmin === true ||
                                  ticketData.status === "Escalated to L2" ||
                                  ticketData.originalData.grievanceTicketMapEntity?.disable === true ||
                                  // Level-specific acceptance checks - only enable for the user who accepted
                                  (userLevel === "L1" &&
                                    (ticketData.originalData.accept === false ||
                                      (ticketData.originalData.accept === true && ticketData.originalData.acceptedBy !== currentUserId))) ||
                                  (userLevel === "L2" &&
                                    (ticketData.originalData.acceptToL2 === false ||
                                      (ticketData.originalData.acceptToL2 === true && ticketData.originalData.acceptedByL2 !== currentUserId))) ||
                                  (userLevel === "L3" &&
                                    (ticketData.originalData.acceptToL3 === false ||
                                      (ticketData.originalData.acceptToL3 === true && ticketData.originalData.acceptedByL3 !== currentUserId)))
                                  : isAdmin === true ||
                                  ticketData.status === "Resolved" ||
                                  ticketData.originalData.grievanceTicketMapEntity?.disable !== false;
                                return shouldDisableDropdown ? 0.4 : 1;
                              })(),
                              color: (() => {
                                const hasUserLevel = userLevel !== null && userLevel !== undefined;
                                const currentUserId = user;
                                const shouldDisableDropdown = hasUserLevel
                                  ? isStatusClosedOrRejected ||
                                  hasActionMessage ||
                                  userRole === "SUPER ADMIN" ||
                                  isAdmin === true ||
                                  ticketData.status === "Escalated to L2" ||
                                  ticketData.originalData.grievanceTicketMapEntity?.disable === true ||
                                  // Level-specific acceptance checks - only enable for the user who accepted
                                  (userLevel === "L1" &&
                                    (ticketData.originalData.accept === false ||
                                      (ticketData.originalData.accept === true && ticketData.originalData.acceptedBy !== currentUserId))) ||
                                  (userLevel === "L2" &&
                                    (ticketData.originalData.acceptToL2 === false ||
                                      (ticketData.originalData.acceptToL2 === true && ticketData.originalData.acceptedByL2 !== currentUserId))) ||
                                  (userLevel === "L3" &&
                                    (ticketData.originalData.acceptToL3 === false ||
                                      (ticketData.originalData.acceptToL3 === true && ticketData.originalData.acceptedByL3 !== currentUserId)))
                                  : isAdmin === true ||
                                  ticketData.status === "Resolved" ||
                                  ticketData.originalData.grievanceTicketMapEntity?.disable !== false;
                                return shouldDisableDropdown ? "#666" : "inherit";
                              })()
                            }}
                            value={escalationType}
                            onChange={(e) => setEscalationType(e.target.value)}
                            disabled={(() => {
                              // Check if userlevel exists in the themeURL response
                              const hasUserLevel = userLevel !== null && userLevel !== undefined;
                            
                              // Get the current user ID from your user profile
const currentUserId = user; // This should be the logged-in user's ID
 
// Determine if dropdown should be disabled with user-specific acceptance checks
const shouldDisableDropdown = hasUserLevel
  ? isStatusClosedOrRejected ||
    hasActionMessage ||
    userRole === "SUPER ADMIN" ||
    isAdmin === true ||
    ticketData.status === "Escalated to L2" ||
    ticketData.originalData.grievanceTicketMapEntity?.disable === true ||
    // Level-specific acceptance checks - only enable for the user who accepted
    (userLevel === "L1" &&
     (ticketData.originalData.accept === false ||
      (ticketData.originalData.accept === true && ticketData.originalData.acceptedBy !== currentUserId))) ||
    (userLevel === "L2" &&
     (ticketData.originalData.acceptToL2 === false ||
      (ticketData.originalData.acceptToL2 === true && ticketData.originalData.acceptedByL2 !== currentUserId))) ||
    (userLevel === "L3" &&
     (ticketData.originalData.acceptToL3 === false ||
      (ticketData.originalData.acceptToL3 === true && ticketData.originalData.acceptedByL3 !== currentUserId)))
  : isAdmin === true ||
    ticketData.status === "Resolved" ||
    ticketData.originalData.grievanceTicketMapEntity?.disable !== false;
                          return shouldDisableDropdown;
                            })()}
                          >
                            <option value="">Select Type</option>
                            <option value="manual">Manual Escalation</option>
                            <option value="cross">Cross Department Transfer</option>
                          </select>
                        )}
                      </div>
<div>
    {/* Manual Escalation Section */}
    {escalationType === 'manual' && (
      <div style={{ padding: "16px", paddingTop: "0" }}>
        {/* <p
          className="mb-2"
          style={{
            color: "#FFA100",
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "0.5px",
          }}
        >
          Manual Escalation Level
        </p> */}
        <div className="mb-0">
          {isStatusClosedOrRejected ||
          hasActionMessage ||
          userRole === "SUPER ADMIN" ||
          isAdmin === true ||
          ticketData.originalData.grievanceTicketMapEntity.disable === true ||
          userLevel !== ticketData.originalData.userLevel ? (
            <p
              className="mb-0"
              style={{
                fontWeight: "500",
                fontSize: "14px",
                color: "#1e293b",
                padding: "8px 12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                minHeight: "47px",
              }}
            >
              {ticketData.originalData.userLevel
                ? `Escalated to ${ticketData.originalData.userLevel}`
                : "N/A"}
            </p>
          ) : (
            <select
              className="form-select"
              style={{
                // width: "100%",
                borderColor: "black",
                borderRadius: "8px",
                // padding: "8px 12px",
                fontSize: "14px",
                backgroundColor: "white",
                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                fontWeight: "500",
                // maxWidth: "200px",
              }}
              value={escalationLevel || ""}
              onChange={onEscalationLevelChange}
              disabled={escalationLevel !== ""}
            >
              <option value="">Select Level</option>
              {userLevel === "L1" && (
                <option value="L2">L2</option>
              )}
              {userLevel === "L2" && (
                <>
                  <option value="L1">L1</option>
                  <option value="L3">L3</option>
                </>
              )}
              {userLevel === "L3" && (
                <option value="L2">L2</option>
              )}
            </select>
          )}

          {showEscalationModal && (
            <Modal
              show={showEscalationModal}
              onHide={handleEscalationModalClose}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Escalate to {escalationLevel}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="form-group">
                  <label htmlFor="escalationComment" className="form-label">
                    Escalation Remarks <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="escalationComment"
                    className="form-control"
                    rows="4"
                    value={escalationComment}
                    onChange={(e) => setEscalationComment(e.target.value)}
                    placeholder="Please provide details for escalating this ticket..."
                    // style={{
                    //   border: escalationComment.trim() === '' ? '1px solid #dc3545' : '1px solid #ced4da'
                    // }}
                  />
                  {escalationComment.trim() === '' && (
                    <div className="text-danger small mt-1">Escalation Remarks is required</div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={handleEscalationModalClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={submitEscalation}
                  disabled={escalationComment.trim() === ''}
                  className="custom-escalation-btn"
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      </div>
    )}

    {/* Cross Department Section */}
    {escalationType === 'cross' && (
      <div style={{ padding: "16px", paddingTop: "0" }}>
        <div className="mb-0">
          {isStatusClosedOrRejected ||
          hasActionMessage ||
          userRole === "SUPER ADMIN" ||
          isAdmin === true ||
          ticketData.originalData.grievanceTicketMapEntity.disable === true ||
          userLevel !== ticketData.originalData.userLevel ? (
            <p
              className="mb-0"
              style={{
                fontWeight: "500",
                fontSize: "14px",
                color: "#1e293b",
                padding: "8px 12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                minHeight: "47px",
              }}
            >
              {ticketData.originalData.crossDepartment 
                ? `Escalated to ${ticketData.originalData.crossDepartment}`
                : "N/A"}
            </p>
          ) : (
            <div>
              <button
                className="btn btn-primary cross-department-btn"
                onClick={() => setShowCrossDepartmentModal(true)}
                style={{
                width: "100%",
                }}
              >
                Initiate Cross Department
              </button>
            </div>
          )}
        </div>

        {/* Cross Department Modal */}
{showCrossDepartmentModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    }}
    onClick={() => setShowCrossDepartmentModal(false)}
  >
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
        width: "60%",
        maxWidth: "1200px",
        maxHeight: "90vh",
        overflow: "auto",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div
        style={{
          padding: "20px 24px",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
          Cross Department Transfer
        </h5>
        <button
          onClick={() => {
        setShowCrossDepartmentModal(false);
        resetCrossDepartmentForm(); // Add this line
        }}
          style={{
            background: "none",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            color: "#6b7280",
            lineHeight: 1,
          }}
        >
          &times;
        </button>
      </div>

      {/* Body */}
      <div style={{ padding: "24px" }}>
        <div className="container-fluid">
          <div style={{ marginBottom: "24px" }}>
            <h6 style={{ 
              fontSize: "14px", 
              fontWeight: "600", 
              color: "#1a7a73",
              marginBottom: "16px",
              paddingBottom: "8px",
              borderBottom: "2px solid #1a7a73"
            }}>
              Ticket Information (Source Details)
            </h6>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">Ticket ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.id || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">Current Department</label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.originalData?.assignedTeamName || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">Bank Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.bank || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">Branch Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.branch || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">Category</label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.type || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">Subcategory</label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.issueTypeSubCatName || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
              </div>
            </div>
          </div>
        </div>
          
          <div style={{ marginBottom: "24px" }}>
            <h6 style={{ 
              fontSize: "14px", 
              fontWeight: "600", 
              color: "#1a7a73",
              marginBottom: "16px",
              paddingBottom: "8px",
              borderBottom: "2px solid #1a7a73"
            }}>
              Cross Department Transfer Details
            </h6>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">
                  Target Department <span className="text-danger">*</span>
                </label>
                  <select
  className="form-select"
  value={transferData.targetDepartment}
  onChange={(e) => setTransferData({
    ...transferData,
    targetDepartment: e.target.value
  })}
  // style={{
  //   border: transferData.targetDepartment ? '1px solid #ced4da' : '1px solid #dc3545'
  // }}
>
  <option value="">Select Target Department</option>
  {departments.map((dept) => (
    <option key={dept.id} value={dept.id}>
      {dept.name || dept.department_name || dept.team_name}
    </option>
  ))}
</select>
                {!transferData.targetDepartment && (
                  <div className="text-danger small mt-1">Target Department is required</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">
                  L1 Users List
                </label>
                <select
                  className="form-select"
                  value={crossDepartmentUserId || ''}
                  onChange={(e) => setCrossDepartmentUserId(e.target.value)}
                >
                  <option value="">Select User</option>
                  {crossDepartmentLOUsers.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.first_name} {user.last_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">
                  Priority
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={ticketData?.criticality || "N/A"}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa" }}
                />
          </div>
          </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">
                  SLA Deadline
                </label>
              <input
              type="datetime-local"
              className={`form-control branch-input-form-control ${
                slaDeadlineError ? "is-invalid" : ""
              }`}
              style={{
                      backgroundPosition: "right 2.3rem center", // 👈 moves the red "!" slightly left
                    }}
              value={customPriority || calculatePriorityDateTime()}
              onChange={(e) => {
                const selectedDateTime = new Date(e.target.value);
                const currentDateTime = new Date();
                
                // Set seconds and milliseconds to 0 for fair comparison
                selectedDateTime.setSeconds(0, 0);
                currentDateTime.setSeconds(0, 0);
                
                if (selectedDateTime < currentDateTime) {
                  setSlaDeadlineError("SLA deadline cannot be set in the past. Please choose a valid current or future date and time.");
                  setCustomPriority(e.target.value); // Still set the value to show what user selected
                } else {
                  setSlaDeadlineError("");
                  setCustomPriority(e.target.value);
                }
              }}
              min={(() => {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                return `${year}-${month}-${day}T${hours}:${minutes}`;
              })()}
            />
            {slaDeadlineError && (
              <div className="invalid-feedback d-block">
                {slaDeadlineError}
              </div>
            )}
          </div>
          </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                    <label className="form-label fw-semibold">Transfer Type</label>
                      <select
                className="form-select"
                value={transferData.transferType}
                onChange={(e) => setTransferData({
                  ...transferData,
                  transferType: e.target.value
                })}
                // style={{
                //   border: transferData.transferType ? '1px solid #ced4da' : '1px solid #dc3545'
                // }}
              >
                <option value="">Select Transfer Type</option>
                <option value="Escalation">Escalation</option>
                <option value="Reassignment">Reassignment</option>
                <option value="Reallocation">Reallocation</option>
              </select>
              {/* {!transferData.transferType && (
                <div className="text-danger small mt-1">Transfer Type is required</div>
              )} */}
            </div>
            </div>
          </div>


          <div className="row">
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label fw-semibold">
                  Transfer Reason <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Explain why this transfer is necessary..."
                  value={transferData.transferReason}
                  onChange={(e) => setTransferData({
                    ...transferData,
                    transferReason: e.target.value
                  })}
                  // style={{
                  //   border: transferData.transferReason ? '1px solid #ced4da' : '1px solid #dc3545'
                  // }}
                />
                {!transferData.transferReason && (
                  <div className="text-danger small mt-1">Transfer Reason is required</div>
                )}
              </div>
            </div>
          </div>

            <div className="row">
            <div className="col-md-12">
              <div className="form-group mb-3">
            <label htmlFor="attachments" className="form-label d-flex justify-content-between fw-semibold">
              <span>Attachments</span>
              <span className="text-muted">+</span>
            </label>
            <div className="border rounded p-3 text-center" style={{ minHeight: '10px' }}>
              <input
                type="file"
                className="d-none"
                id="attachments"
                onChange={handleImageChange}
                multiple
                accept=".jpg,.jpeg,.png,.gif,.pdf"
              />
              <label htmlFor="attachments" className="mb-0" style={{ cursor: 'pointer' }}>
                <div className="text-muted">Click here to browse</div>
              </label>

              {selectedImages.length > 0 && (
                <div className="mt-3 d-flex flex-wrap">
                  {selectedImages.map((imgObj, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        margin: "5px",
                        display: "inline-block",
                      }}
                    >
                      {isPdf(imgObj.file) ? (
                        <div style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          padding: "5px"
                        }}>
                          <div style={{
                            fontSize: "24px",
                            color: "red"
                          }}>
                            PDF
                          </div>
                          <div style={{
                            fontSize: "10px",
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%"
                          }}>
                            {imgObj.file.name}
                          </div>
                        </div>
                      ) : (
                        <img
                          src={imgObj.preview}
                          alt={`preview-${index}`}
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                        />
                      )}
                      <button
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          color: "black",
                          border: "none",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#ffffff",
                          boxShadow: "0 0 3px rgba(0,0,0,0.3)"
                        }}
                        title="Remove attachment"
                      >
                        ✖
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <small className="text-muted">
              Allowed formats: JPG, PNG, GIF, PDF (max 1MB each, 5 files maximum)
            </small>
            {fileErrors.length > 0 && (
              <div className="mt-2">
                {fileErrors.map((error, index) => (
                  <div key={index} className="text-danger small">
                    {error}
                  </div>
                ))}
              </div>
            )}
          </div>
          </div>
          </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "16px 24px",
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <button
          className="btn btn-secondary"
          onClick={() => {
            setShowCrossDepartmentModal(false);
            resetCrossDepartmentForm();
            setTransferData({
              targetDepartment: '',
              transferReason: '',
              transferType: '',
              supportingRemarks: ''
            });
          }}
          disabled={isSubmittingCrossDepartment}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary cross-department-btn"
          onClick={handleCrossDepartmentTransfer}
          // disabled={!transferData.targetDepartment || !transferData.transferReason || !transferData.transferType}
        disabled={isSubmittingCrossDepartment || !transferData.targetDepartment || !transferData.transferReason || slaDeadlineError }
  >
    {isSubmittingCrossDepartment ? (
      <>
        <span 
          className="spinner-border spinner-border-sm me-2" 
          role="status" 
          aria-hidden="true"
        ></span>
        Submitting...
      </>
    ) : (
      "Submit"
    )}
  </button>
      </div>
    </div>
  </div>
)}
      </div>
    )}
</div>

    </div>
    </div>
                  </div>
                </div>
              )}
{ticketData?.originalData?.oldGrievanceInformationEntity[0]?.reOpenedRemarks && (
  <div className="row">
    <div className={!userLevel && !ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage ? "col-1" : "col-6"} style={{ padding: "16px", marginLeft: collapsed && !userLevel && !ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage
  ? "-102px"
  : !userLevel && !ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage
  ? "-90px"
  : ""
}}>
      {/* Empty space to maintain layout consistency with Action Type section */}
    </div>
    
    <div className="col-3" style={{marginTop: ticketData?.originalData?.grievanceTicketMapEntity?.actionMessage 
  ? "-89px" 
  : !userLevel 
    ? "0px" 
    : "-100px"
, marginLeft:"6px"}}>
      <div style={{ padding: "16px" }}>
        <p
          className="mb-2"
          style={{
            color: "#FFA100",
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "0.5px",
          }}
        >
          Reopened Date & Time
        </p>
        <p
          className="mb-0"
          style={{
            fontWeight: "500",
            fontSize: "14px",
            color: "#1e293b",
          }}
        >
          {formatReopenedDateTime(
            ticketData.originalData?.oldGrievanceInformationEntity[0]?.reOpenedDateAndTime
          )}
        </p>
      </div>
    </div>
  </div>
)}
                

                {ticketData?.originalData?.oldGrievanceInformationEntity[0]
                  ?.reOpenedRemarks && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(280px, 1fr))",
                      gap: "14px",
                      marginBottom: "10px",
                    }}
                  >                  
                    {/* <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Reopened Date & Time
                      </p>
                      <p
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {formatReopenedDateTime(
                          ticketData.originalData
                            ?.oldGrievanceInformationEntity[0]
                            ?.reOpenedDateAndTime
                        )}
                      </p>
                    </div> */}
                    <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Reopened Remarks
                      </p>
                      <p
                        className="mb-0"
                        style={{
                          // fontWeight: "600",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {
                          ticketData.originalData
                            ?.oldGrievanceInformationEntity[0]?.reOpenedRemarks
                        }
                      </p>
                    </div>
                  </div>
                )}
              </div>
              </div>
              
            </div>




            {/* Cross department Information */}
{userLevel && ticketData?.originalData?.crossDeptDisable === true &&
<div
  className="mb-4"
  style={{
    backgroundColor: "white",
    borderRadius: "10px",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  }}
>
  {/* Header */}
  <div
    style={{
      padding: "20px 20px 0px 0px",
      color: "#1a7a73",
    }}
  >
    <h6
      style={{
        fontSize: "15px",
        fontWeight: "600",
        margin: 0,
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <i
        className="bi bi-person-circle"
        style={{ fontSize: "15px" }}
      ></i>
      Cross-Department Assignment
    </h6>
  </div>

                <div className="row">
                  <div className="col-4">
                    <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Target Department
                      </p>
                      <p
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {displayData(ticketData?.originalData?.handledBy)}
                      </p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Priority
                      </p>
                      <p
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {displayData(ticketData?.originalData?.priority)}

                      </p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        SLA Deadline
                      </p>
                      <div
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {ticketData?.originalData?.resSLADateAndTime
                          ? (() => {
                            const d = new Date(ticketData.originalData.resSLADateAndTime);
                            const day = String(d.getDate()).padStart(2, "0");
                            const month = String(d.getMonth() + 1).padStart(2, "0");
                            const year = d.getFullYear();

                            let hours = d.getHours();
                            const minutes = String(d.getMinutes()).padStart(2, "0");
                            const ampm = hours >= 12 ? "PM" : "AM";
                            hours = hours % 12 || 12;

                            return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
                          })()
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Transfer Type
                      </p>
                      <div
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {displayData(ticketData?.originalData?.crossDepartmentTransfers?.[0]?.transferType)}
                      </div>
                    </div>
                  </div>
                  <div className="col-8">
                    <div
                      style={{
                        padding: "16px",
                        // backgroundColor: "#f8fafc",
                        // borderRadius: "12px",
                        // border: "1px solid #e2e8f0"
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          color: "#FFA100",
                          fontSize: "12px",
                          fontWeight: "600",

                          letterSpacing: "0.5px",
                        }}
                      >
                        Transfer Reason
                      </p>
                      <div
                        className="mb-0"
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#1e293b",
                        }}
                      >
                        {displayData(ticketData?.originalData?.crossDepartmentTransfers?.[0]?.transferReason)}
                      </div>
                    </div>
                  </div>
                </div>


                 

<div
    style={{
      padding: "20px 20px 0px 0px",
      color: "#1a7a73",
    }}
  >
    <h6
      style={{
        fontSize: "15px",
        fontWeight: "600",
        margin: 0,
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <i
        className="bi bi-person-circle"
        style={{ fontSize: "15px" }}
      ></i>
      Transfer History
    </h6>
  </div>

  {/* Content */}
                <div style={{ padding: "15px", marginTop: "10px" }}>
                  {ticketData?.originalData?.crossDepartmentTransfers &&
                    ticketData.originalData.crossDepartmentTransfers.length > 0 ? (
                    (() => {
                      // Filter for transfers with isLatest === false
                      const historyTransfers = ticketData.originalData.crossDepartmentTransfers.filter(
                        transfer => transfer.isLatest === false
                      );

                      // Check if there are any history transfers
                      if (historyTransfers.length === 0) {
                        return (
                          <p className="text-muted text-center" style={{ fontSize: "14px", padding: "20px 0" }}>
                            No transfer history available. Transfer records will be displayed here once the ticket is transferred.</p>
                        );
                      }

                      // Show table if there are history transfers
                      return (
                        <div style={{ overflowX: "auto" }}>
                          <table
                            className="table table-hover"
                            style={{
                              width: "100%",
                              borderCollapse: "separate",
                              borderSpacing: "0",
                              fontSize: "14px",
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: "#f8fafc" }}>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                  borderTopLeftRadius: "8px",
                                }}>
                                  S.No
                                </th>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                }}>
                                  Previous Handling Department
                                </th>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                }}>
                                  Priority
                                </th>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                }}>
                                  SLA Deadline
                                </th>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                }}>
                                  Transfer Type
                                </th>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                }}>
                                  Transfer Reason
                                </th>
                                <th style={{
                                  padding: "12px 16px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  borderBottom: "2px solid #1a7a73",
                                  verticalAlign: "middle",
                                  backgroundColor: "#1a7a73",
                                  borderTopRightRadius: "8px",
                                }}>
                                  Assigned Date & Time
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {historyTransfers.map((transfer, index) => (
                                <tr
                                  key={transfer.id || index}
                                  style={{
                                    borderBottom: "1px solid #e2e8f0",
                                  }}
                                >
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    fontWeight: "500",
                                    verticalAlign: "middle",
                                  }}>
                                    {index + 1}
                                  </td>
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    fontWeight: "500",
                                    verticalAlign: "middle",
                                  }}>
                                    {transfer.targetDepartmentName}
                                  </td>
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    verticalAlign: "middle",
                                  }}>
                                    {ticketData?.originalData?.priority ? (
                                      <span style={{
                                        padding: "4px 12px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        display: "inline-block",
                                        backgroundColor:
                                          ticketData.originalData.priority === "Critical" ? "#FEE2E2" :
                                            ticketData.originalData.priority === "High" ? "#FEF3C7" :
                                              ticketData.originalData.priority === "Medium" ? "#ccfbf1" :
                                                "#F3F4F6",
                                        color:
                                          ticketData.originalData.priority === "Critical" ? "#DC2626" :
                                            ticketData.originalData.priority === "High" ? "#D97706" :
                                              ticketData.originalData.priority === "Medium" ? "#1a7a73" :
                                                "#6B7280"
                                      }}>
                                        {ticketData.originalData.priority}
                                      </span>
                                    ) : (
                                      <span style={{ color: "#94a3b8" }}>N/A</span>
                                    )}
                                  </td>
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    verticalAlign: "middle",
                                  }}>
                                    {transfer.slaDateTime ? (
                                      (() => {
                                        const date = new Date(transfer.slaDateTime);
                                        const day = date.getDate().toString().padStart(2, "0");
                                        const month = (date.getMonth() + 1).toString().padStart(2, "0");
                                        const year = date.getFullYear();

                                        let hours = date.getHours();
                                        const minutes = date.getMinutes().toString().padStart(2, "0");
                                        const ampm = hours >= 12 ? "PM" : "AM";
                                        hours = hours % 12 || 12;
                                        const formattedTime = `${hours}:${minutes} ${ampm}`;

                                        return `${day}-${month}-${year} ${formattedTime}`;
                                      })()
                                    ) : (
                                      <span style={{ color: "#94a3b8" }}>N/A</span>
                                    )}
                                  </td>
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    verticalAlign: "middle",
                                  }}>
                                    {transfer.transferType || <span style={{ color: "#94a3b8" }}>N/A</span>}
                                  </td>
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    maxWidth: "200px",
                                    verticalAlign: "middle",
                                  }}>
                                    {transfer.transferReason ? (
                                      <span
                                        onClick={() => openTransferReasonModal(transfer.transferReason)}
                                        style={{
                                          maxWidth: "180px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          display: "inline-block",
                                          cursor: "pointer",
                                        }}
                                        title="Click to view full reason"
                                      >
                                        {transfer.transferReason}
                                      </span>
                                    ) : (
                                      <span style={{ color: "#94a3b8" }}>N/A</span>
                                    )}
                                  </td>
                                  <td style={{
                                    padding: "12px 16px",
                                    color: "#1e293b",
                                    verticalAlign: "middle",
                                  }}>
                                    {transfer.created_on ? (
                                      (() => {
                                        const d = new Date(transfer.created_on);
                                        const day = String(d.getDate()).padStart(2, "0");
                                        const month = String(d.getMonth() + 1).padStart(2, "0");
                                        const year = d.getFullYear();

                                        let hours = d.getHours();
                                        const minutes = String(d.getMinutes()).padStart(2, "0");
                                        const ampm = hours >= 12 ? "PM" : "AM";
                                        hours = hours % 12 || 12;

                                        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
                                      })()
                                    ) : (
                                      <span style={{ color: "#94a3b8" }}>NA</span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    })()
                  ) : (
                    <div
                      className="text-center py-4"
                      style={{
                        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                        borderRadius: "12px",
                        border: "2px dashed #cbd5e1",
                        padding: "32px 16px",
                      }}
                    >
                      <i className="bi bi-inbox" style={{ fontSize: "48px", color: "#cbd5e1", marginBottom: "12px" }}></i>
                      <p className="text-muted mt-2 mb-0" style={{ fontSize: "14px", fontWeight: "500", color: "#64748b" }}>
                        No transfer history available
                      </p>
                      <p className="text-muted mb-0" style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>
                        Transfer records will appear here once the ticket is transferred
                      </p>
                    </div>
                  )}
                </div>
              </div>
}

{showTransferReasonModal && (
  <div
    className="modal"
    style={{
      display: "block",
      position: "fixed",
      zIndex: 1050,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      backgroundColor: "rgba(0,0,0,0.4)",
    }}
    onClick={closeTransferReasonModal}
  >
    <div
      className="modal-dialog modal-lg"
      style={{
        position: "relative",
        width: "auto",
        margin: "1.75rem auto",
        maxWidth: "600px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid rgba(0,0,0,.2)",
          borderRadius: "0.3rem",
          boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
        }}
      >
        <div
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem 1rem",
            borderBottom: "1px solid #dee2e6",
            borderTopLeftRadius: "0.3rem",
            borderTopRightRadius: "0.3rem",
          }}
        >
          <h5
            className="modal-title"
            style={{
              margin: 0,
              lineHeight: 1.5,
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "16px",
            }}
          >
            Transfer Reason
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeTransferReasonModal}
            style={{
              padding: 0,
              background: "none",
              border: 0,
              fontSize: "1.5rem",
              fontWeight: 700,
              lineHeight: 1,
              color: "#000",
              textShadow: "0 1px 0 #fff",
              opacity: 0.5,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
        <div
          className="modal-body"
          style={{
            position: "relative",
            flex: "1 1 auto",
            padding: "1rem",
            fontFamily: "Poppins",
            fontSize: "14px",
            lineHeight: "1.6",
            wordWrap: "break-word",
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          {selectedTransferReason}
        </div>
        <div
          className="modal-footer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0.75rem",
            borderTop: "1px solid #dee2e6",
            borderBottomRightRadius: "0.3rem",
            borderBottomLeftRadius: "0.3rem",
          }}
        >
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeTransferReasonModal}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
              padding: "0.375rem 0.75rem",
              fontSize: "0.875rem",
              lineHeight: 1.5,
              borderRadius: "0.25rem",
              border: "1px solid transparent",
              cursor: "pointer",
              fontFamily: "Poppins",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}

            {/* Customer Information Card */}
            <div
              className="mb-4"
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e2e8f0",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                style={{
                  // background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  padding: "20px 24px",
                  color: "#1a7a73",
                }}
              >
                <h6
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i
                    className="bi bi-person-circle"
                    style={{ fontSize: "15px" }}
                  ></i>
                  Requestor Information
                </h6>
              </div>

              {/* Content */}
              <div style={{ padding: "15px", marginTop: "-15px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: "14px",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Requestor User ID
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.customerName)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Requestor Contact Number
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.phoneNumber)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Requestor Email Address
                    </p>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.email)}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: "16px",
                      // backgroundColor: "#f8fafc",
                      // borderRadius: "12px",
                      // border: "1px solid #e2e8f0"
                    }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        color: "#FFA100",
                        fontSize: "12px",
                        fontWeight: "600",

                        letterSpacing: "0.5px",
                      }}
                    >
                      Preferred Resolution Method
                    </p>
                    <div
                      className="mb-0"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1e293b",
                      }}
                    >
                      {displayData(ticketData?.resolutionMethod)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Images & Videos Section */}
            <div
              className="mb-4"
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e2e8f0",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                style={{
                  padding: "20px 24px",
                  color: "#1a7a73",
                }}
              >
                <h6
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="bi bi-images" style={{ fontSize: "14px" }}></i>
                  Attached Media
                </h6>
              </div>

              {/* Content */}
              <div style={{ padding: "15px", marginTop: "-15px" }}>
                {mediaList.length > 0 ? (
                  <div>
                    <div
                      className="d-flex position-relative"
                      style={{
                        marginBottom: "20px",
                        gap: "16px",
                        overflowX: "auto",
                        paddingBottom: "10px",
                      }}
                    >
                      {mediaList.map((media, index) => {
                        const isPdf = isPdfFile(media.mediaPath);
                        const isVideo =
                          media.mediaPath?.toLowerCase().endsWith(".mp4") ||
                          media.mediaPath?.toLowerCase().endsWith(".mov") ||
                          media.mediaPath?.toLowerCase().endsWith(".avi") ||
                          media.mediaPath?.toLowerCase().endsWith(".webm");

                        return (
                          <div
                            key={media.id || index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              flexShrink: 0,
                              width: "100px",
                            }}
                          >
                            {/* Media Thumbnail */}
                            <div
                              className="position-relative"
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "10px",
                                overflow: "hidden",
                                cursor: "pointer",
                                border:
                                  index === currentImageIndex
                                    ? "3px solid #1a7a73"
                                    : "1px solid #e2e8f0",
                                marginBottom: "8px",
                              }}
                              onClick={() => handleMediaClick(media, index)}
                              onMouseEnter={(e) => {
                                if (index !== currentImageIndex) {
                                  e.currentTarget.style.transform =
                                    "scale(1.02)";
                                  e.currentTarget.style.boxShadow =
                                    "0 8px 25px -5px rgba(0, 0, 0, 0.25)";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (index !== currentImageIndex) {
                                  e.currentTarget.style.transform = "scale(1)";
                                  e.currentTarget.style.boxShadow =
                                    "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
                                }
                              }}
                            >
                              {isPdf ? (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    background:
                                      "linear-gradient(135deg, #fee2e2, #fecaca)",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity:
                                      index === currentImageIndex ? 1 : 0.8,
                                  }}
                                >
                                  <i
                                    className="bi bi-file-earmark-pdf text-danger"
                                    style={{ fontSize: "32px" }}
                                  ></i>
                                  <small className="text-danger mt-2 fw-bold">
                                    PDF
                                  </small>
                                </div>
                              ) : isVideo ? (
                                <video
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    opacity:
                                      index === currentImageIndex ? 1 : 0.8,
                                  }}
                                  muted
                                >
                                  <source
                                    src={media.mediaPath}
                                    type="video/mp4"
                                  />
                                  Your browser does not support the video tag.
                                </video>
                              ) : (
                                <img
                                  src={media.mediaPath}
                                  alt={media.fileName || `Media ${index + 1}`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    opacity:
                                      index === currentImageIndex ? 1 : 0.8,
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              )}

                              {/* Fallback for broken images */}
                              <div
                                style={{
                                  display: "none",
                                  width: "100%",
                                  height: "100%",
                                  background:
                                    "linear-gradient(135deg, #f3f4f6, #e5e7eb)",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#6b7280",
                                  fontSize: "12px",
                                  textAlign: "center",
                                }}
                              >
                                <div>
                                  <i
                                    className="bi bi-image"
                                    style={{
                                      fontSize: "24px",
                                      marginBottom: "8px",
                                    }}
                                  ></i>
                                  <div>Image not found</div>
                                </div>
                              </div>
                            </div>

                            {/* File name below the thumbnail */}
                            {media.fileName && (
                              <div
                                style={{
                                  fontSize: "11px",
                                  color: "#6b7280",
                                  textAlign: "center",
                                  fontWeight: "500",
                                  width: "100px",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  padding: "0 4px",
                                }}
                                title={getFileNameWithoutExtension(
                                  media.fileName
                                )}
                              >
                                {getFileNameWithoutExtension(media.fileName)}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div
                    className="text-center py-2"
                    style={{
                      background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                      borderRadius: "12px",
                      border: "2px dashed #cbd5e1",
                    }}
                  >
                    <i
                      className="bi bi-image text-muted"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <p
                      className="text-muted mt-1 mb-0"
                      style={{ fontSize: "14px", fontWeight: "500" }}
                    >
                      No attachments available
                    </p>
                  </div>
                )}
              </div>
            </div>
            <MediaModal />
            {renderAttachmentsSection()}
            {renderCommentsSection()}
            {renderSubmitButtons()}
          </div>
        </div>
      </div>
    );
  };

  return renderTicketView();
};

export default ViewRaisedTicket;
